<svg focusable="false" aria-hidden="true" [class]="iconClass()">
	<use [attr.xlink:href]="'#' + name()"></use>
</svg>

<svg style="display: none" xmlns="http://www.w3.org/2000/svg">
	<symbol [id]="ICONS.success" viewBox="0 0 32 32">
		<path
			fill="#d4eaa9"
			opacity="0.32"
			style="fill: var(--color1, #d4eaa9)"
			d="M16 31.304c-8.544 0-15.492-6.948-15.492-15.492s6.948-15.492 15.492-15.492 15.492 6.948 15.492 15.492-6.948 15.492-15.492 15.492z"
		></path>
		<path
			fill="#88cc2a"
			style="fill: var(--color2, #88cc2a)"
			d="M16 23.956c-4.492 0-8.144-3.652-8.144-8.144s3.652-8.144 8.144-8.144 8.144 3.656 8.144 8.144-3.652 8.144-8.144 8.144z"
		></path>
		<path
			fill="#7fb335"
			style="fill: var(--color3, #7fb335)"
			d="M24.144 15.812c0-4.488-3.652-8.144-8.144-8.144v16.292c4.492-0.004 8.144-3.656 8.144-8.148z"
		></path>
		<path
			fill="#fff"
			style="fill: var(--color4, #fff)"
			d="M15.188 19.476c-0.312 0-0.624-0.12-0.864-0.36l-2.516-2.516c-0.476-0.476-0.476-1.252 0-1.728s1.252-0.476 1.728 0l1.652 1.652 3.484-3.484c0.476-0.476 1.252-0.476 1.728 0s0.476 1.252 0 1.728l-4.352 4.352c-0.236 0.236-0.552 0.356-0.86 0.356z"
		></path>
		<path
			fill="#edf0f2"
			style="fill: var(--color5, #edf0f2)"
			d="M18.672 13.040l-2.672 2.672v3.448c0.016-0.012 0.036-0.028 0.048-0.040l4.352-4.352c0.476-0.476 0.476-1.252 0-1.728s-1.248-0.476-1.728 0z"
		></path>
	</symbol>

	<symbol [id]="ICONS.failed" viewBox="0 0 32 32">
		<path
			fill="#dd4a3a"
			opacity="0.22"
			style="fill: var(--color6, #dd4a3a)"
			d="M16 31.304c-8.544 0-15.492-6.948-15.492-15.492s6.948-15.492 15.492-15.492 15.492 6.948 15.492 15.492-6.948 15.492-15.492 15.492z"
		></path>
		<path
			fill="#dd4a3a"
			style="fill: var(--color6, #dd4a3a)"
			d="M15.9 23.692c-4.492 0-8.148-3.656-8.148-8.148s3.656-8.144 8.148-8.144 8.148 3.656 8.148 8.148-3.656 8.144-8.148 8.144z"
		></path>
		<path
			fill="#c93d27"
			style="fill: var(--color7, #c93d27)"
			d="M24.048 15.544c0-4.492-3.656-8.148-8.148-8.148v16.292c4.492 0.004 8.148-3.652 8.148-8.144z"
		></path>
		<path
			fill="#edf0f2"
			style="fill: var(--color5, #edf0f2)"
			d="M13.456 18.432v0c-0.412-0.316-0.488-0.908-0.172-1.32l3.596-4.668c0.316-0.412 0.908-0.488 1.32-0.172v0c0.412 0.316 0.488 0.908 0.172 1.32l-3.596 4.664c-0.316 0.416-0.908 0.492-1.32 0.176z"
		></path>
		<path
			fill="#edf0f2"
			style="fill: var(--color5, #edf0f2)"
			d="M18.2 18.432v0c0.412-0.316 0.488-0.908 0.172-1.32l-3.596-4.664c-0.316-0.412-0.908-0.488-1.32-0.172v0c-0.412 0.316-0.488 0.908-0.172 1.32l3.596 4.664c0.316 0.412 0.908 0.488 1.32 0.172z"
		></path>
	</symbol>

	<symbol [id]="ICONS.timer" viewBox="0 0 32 32">
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M14.869 16.341c0 0.256 0.107 0.491 0.277 0.661s0.427 0.277 0.661 0.277h4.672c0.512 0 0.939-0.405 0.96-0.917 0.021-0.533-0.405-0.96-0.939-0.96h-3.755v-5.632c0-0.512-0.405-0.939-0.917-0.96-0.533-0.021-0.96 0.405-0.96 0.939v6.592z"
		></path>
		<path
			fill="#26496b"
			style="fill: var(--color2, #26496b)"
			d="M26.496 7.531c0.363 0.363 0.96 0.363 1.344 0 0.363-0.363 0.363-0.96 0-1.344l-1.899-1.899c-0.363-0.363-0.96-0.363-1.344 0-0.363 0.363-0.363 0.96 0 1.344l0.277 0.277-1.088 1.088c-1.92-1.664-4.352-2.731-7.019-2.944 0-0.021 0-0.043 0-0.043v-1.877c0-0.021 0-0.021 0-0.043h1.835c0.512 0 0.939-0.405 0.96-0.917 0.043-0.533-0.384-0.96-0.917-0.96h-5.653c0 0-0.939 0.427-0.939 0.939s0.427 0.939 0.939 0.939h1.92c0 0.021 0 0.021 0 0.043v1.899c0 0 0 0.021 0 0.021-6.357 0.469-11.371 5.781-11.371 12.245 0 6.784 5.504 12.267 12.288 12.288 6.784 0 12.288-5.675 12.288-12.309 0-2.987-1.131-5.781-2.987-7.936l1.088-1.088 0.277 0.277zM26.219 16.277c0 2.837-1.173 5.483-3.051 7.36s-4.48 3.051-7.36 3.051c-2.88 0-5.461-1.152-7.36-3.051-1.877-1.877-3.051-4.48-3.051-7.36s1.173-5.461 3.051-7.36c1.877-1.877 4.48-3.051 7.36-3.051 2.859 0 5.44 1.131 7.317 3.008 0.021 0.021 0.021 0.021 0.021 0.043 0.021 0.021 0.021 0.021 0.043 0.021 1.899 1.941 3.029 4.523 3.029 7.339z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M23.573 30.293c0.299 0 0.533 0.235 0.533 0.533v0c0 0.299-0.235 0.533-0.533 0.533h-14.933c-0.299 0-0.533-0.235-0.533-0.533v0c0-0.299 0.235-0.533 0.533-0.533z"
		></path>
	</symbol>

	<symbol [id]="ICONS.cost" viewBox="0 0 32 32">
		<path
			fill="#26496b"
			style="fill: var(--color2, #26496b)"
			d="M15.765 28.373c-0.853-0.043-1.707-0.043-2.539-0.171-2.261-0.299-4.224-1.301-5.909-2.816-2.197-2.005-3.563-4.523-4.181-7.424-0.512-2.368-0.469-4.757 0.149-7.104 0.704-2.688 2.027-5.013 4.117-6.869 1.984-1.792 4.331-2.773 7.040-2.88 1.856-0.085 3.691-0.043 5.525 0.363 2.773 0.597 5.035 2.027 6.763 4.245 1.323 1.685 2.091 3.605 2.496 5.696 0.341 1.728 0.405 3.477 0.213 5.227-0.171 1.6-0.597 3.136-1.28 4.608-0.811 1.728-1.963 3.2-3.477 4.395-1.493 1.173-3.179 1.92-5.013 2.325-1.28 0.277-2.581 0.384-3.883 0.363-0.021 0.021-0.021 0.021-0.021 0.043zM25.813 14.571c0-0.107 0-0.213 0-0.32-0.064-2.155-0.576-4.203-1.579-6.123-1.109-2.112-2.667-3.819-4.779-4.971-1.92-1.045-3.947-1.408-6.101-1.109-1.984 0.299-3.712 1.131-5.227 2.453-1.643 1.429-2.795 3.157-3.541 5.184-1.067 2.88-1.195 5.803-0.427 8.768 0.619 2.347 1.771 4.395 3.52 6.080 1.515 1.451 3.307 2.432 5.376 2.773 2.624 0.448 5.056-0.107 7.253-1.6 1.963-1.323 3.371-3.136 4.309-5.312 0.853-1.835 1.216-3.797 1.195-5.824zM26.432 11.669c0.021 0.149 0.064 0.277 0.064 0.427 0.021 0.107 0.064 0.128 0.171 0.128 0.533 0 1.067 0 1.579 0 0.043 0 0.085 0 0.128-0.021-0.021-0.128-0.064-0.256-0.064-0.384-0.021-0.107-0.043-0.171-0.171-0.149-0.341 0-0.683 0-1.024 0-0.213 0-0.427 0-0.683 0zM27.435 8.875c-0.064-0.149-0.149-0.299-0.192-0.427-0.043-0.107-0.107-0.128-0.213-0.128-0.512 0-1.045 0-1.557 0-0.043 0-0.085 0-0.149 0.021 0.064 0.149 0.128 0.277 0.171 0.405 0.043 0.107 0.085 0.128 0.192 0.128 0.491 0 0.981 0 1.451 0 0.128 0 0.192 0 0.299 0zM28.16 18.325c-0.619 0-1.195 0-1.771 0-0.043 0-0.085 0.021-0.085 0.064-0.043 0.149-0.085 0.32-0.128 0.469 0.021 0.021 0.021 0.021 0.043 0.021 0.576 0 1.131 0 1.707 0 0.043 0 0.085-0.043 0.107-0.064 0.043-0.149 0.064-0.299 0.128-0.491zM26.667 16.128c-0.021 0.192-0.043 0.341-0.064 0.533 0.619 0 1.195 0 1.771 0 0.021 0 0.085-0.043 0.085-0.064 0.021-0.149 0.043-0.299 0.043-0.469-0.597 0-1.216 0-1.835 0zM24.043 6.101c0.107 0.171 0.192 0.32 0.299 0.448 0.043 0.064 0.128 0.107 0.213 0.107 0.469 0 0.96 0 1.429 0 0.064 0 0.128 0 0.235 0-0.149-0.192-0.256-0.363-0.384-0.512-0.021-0.021-0.064-0.043-0.107-0.043-0.555 0-1.109 0-1.685 0zM26.176 10.56c0.043 0.149 0.085 0.277 0.107 0.427 0.021 0.107 0.064 0.128 0.171 0.128 0.533 0 1.045 0 1.579 0 0.043 0 0.107 0 0.149-0.021-0.043-0.149-0.085-0.277-0.107-0.405-0.021-0.107-0.064-0.128-0.171-0.128-0.469 0-0.96 0-1.429 0-0.107 0-0.192 0-0.299 0zM27.861 10.005c-0.064-0.171-0.107-0.299-0.149-0.427-0.021-0.085-0.085-0.128-0.171-0.128-0.427 0-0.875 0-1.301 0-0.128 0-0.277 0-0.427 0 0.064 0.171 0.107 0.341 0.171 0.491 0.021 0.021 0.064 0.064 0.085 0.064 0.576 0 1.173 0 1.792 0zM26.667 13.312c0.619 0 1.237 0 1.856 0-0.021-0.128-0.021-0.256-0.043-0.384 0-0.107-0.043-0.149-0.171-0.149-0.533 0-1.045 0-1.579 0-0.043 0-0.085 0-0.149 0.021 0.043 0.171 0.064 0.341 0.085 0.512zM28.565 15.552c0-0.171 0-0.341 0-0.533-0.576 0-1.173 0-1.749 0-0.021 0-0.064 0.043-0.085 0.064 0 0.149 0 0.299 0 0.469 0.597 0 1.216 0 1.835 0zM28.373 17.216c-0.597 0-1.195 0-1.771 0-0.021 0-0.085 0.043-0.085 0.064-0.043 0.149-0.064 0.299-0.085 0.469 0.597 0 1.195 0 1.771 0 0.021 0 0.085-0.043 0.085-0.085 0.043-0.128 0.064-0.256 0.085-0.448zM26.731 13.888c0 0.149 0 0.256 0 0.384s0.043 0.171 0.171 0.171c0.491 0 1.003 0 1.493 0 0.064 0 0.107 0 0.171 0 0-0.149 0-0.299 0-0.427 0-0.107-0.043-0.128-0.128-0.128-0.192 0-0.384 0-0.576 0-0.384 0-0.747 0-1.131 0zM26.901 7.765c-0.085-0.171-0.171-0.299-0.235-0.427-0.043-0.085-0.107-0.128-0.213-0.128-0.491 0-1.003 0-1.493 0-0.043 0-0.107 0-0.171 0.021 0.107 0.171 0.171 0.341 0.277 0.491 0.021 0.021 0.064 0.043 0.085 0.043 0.555 0.021 1.131 0 1.749 0zM25.792 19.989c0.597 0 1.173 0 1.749 0 0.043 0 0.085-0.021 0.107-0.064 0.064-0.149 0.128-0.32 0.192-0.491-0.619 0-1.195 0-1.771 0-0.021 0-0.085 0.043-0.085 0.064-0.064 0.171-0.128 0.32-0.192 0.491zM25.344 21.077c0.021 0.021 0.043 0.021 0.043 0.021 0.555 0 1.109 0 1.643 0 0.043 0 0.085-0.021 0.107-0.043 0.085-0.149 0.149-0.32 0.213-0.469-0.021-0.021-0.043-0.021-0.043-0.021-0.555 0-1.131 0-1.685 0-0.043 0-0.085 0.043-0.107 0.064-0.043 0.149-0.085 0.299-0.171 0.448zM23.147 5.013c0.149 0.171 0.256 0.32 0.384 0.448 0.043 0.043 0.128 0.085 0.192 0.085 0.469 0 0.939 0 1.408 0 0.043 0 0.085 0 0.171-0.021-0.085-0.107-0.171-0.171-0.213-0.256-0.171-0.235-0.384-0.32-0.683-0.299-0.405 0.043-0.811 0.043-1.259 0.043zM26.816 21.696c-0.043-0.021-0.043-0.021-0.064-0.021-0.533 0-1.067 0-1.621 0-0.043 0-0.085 0.021-0.107 0.043-0.085 0.149-0.171 0.32-0.256 0.469 0.043 0.021 0.043 0.021 0.064 0.021 0.533 0 1.045 0 1.579 0 0.043 0 0.085-0.021 0.107-0.043 0.107-0.149 0.192-0.299 0.299-0.469zM24.043 23.317c0.555 0 1.067 0 1.579 0 0.021 0 0.064 0 0.085-0.021 0.128-0.149 0.256-0.32 0.384-0.469-0.043-0.021-0.043-0.021-0.043-0.021-0.512 0-1.045 0-1.557 0-0.043 0-0.085 0.021-0.107 0.043-0.128 0.128-0.213 0.299-0.341 0.469zM24.149 4.416c-0.213-0.171-0.384-0.32-0.576-0.448-0.064-0.043-0.171-0.085-0.235-0.085-0.384 0-0.768 0-1.131 0-0.043 0-0.085 0-0.149 0.021 0.171 0.171 0.32 0.299 0.469 0.427 0.064 0.043 0.149 0.085 0.235 0.085 0.405 0 0.832 0 1.237 0 0.021 0.021 0.064 0.021 0.149 0zM25.173 23.915c-0.064-0.021-0.064-0.021-0.085-0.021-0.469 0-0.939 0-1.408 0-0.021 0-0.064 0-0.085 0.021-0.149 0.171-0.277 0.32-0.448 0.533 0.512 0 0.981 0 1.451 0 0.021 0 0.064-0.021 0.085-0.043 0.171-0.149 0.32-0.32 0.491-0.491zM23.957 25.045c0-0.021-0.021-0.021-0.021-0.043-0.427 0-0.853 0-1.259 0-0.021 0-0.064 0-0.085 0.021-0.171 0.171-0.363 0.341-0.576 0.533 0.427 0 0.832 0 1.216 0 0.021 0 0.043 0 0.064-0.021 0.235-0.171 0.448-0.341 0.661-0.491zM20.587 2.795c0 0.021 0 0.021-0.021 0.043 0.064 0.043 0.149 0.085 0.213 0.149 0.363 0.341 0.789 0.427 1.259 0.363 0.171-0.021 0.341 0 0.491 0 0-0.021 0-0.043 0.021-0.043-0.299-0.149-0.597-0.32-0.896-0.469-0.021-0.021-0.064-0.021-0.085-0.021-0.32-0.043-0.64-0.021-0.981-0.021zM22.336 26.155c0-0.021 0-0.021 0-0.043-0.32 0-0.619 0-0.939 0-0.021 0-0.064 0-0.085 0.021-0.256 0.171-0.491 0.341-0.747 0.512 0.192 0.021 0.363 0.043 0.533 0.021 0.107 0 0.213 0 0.299-0.021 0.299-0.171 0.619-0.341 0.939-0.491zM20.181 2.197c-0.619-0.235-1.259-0.427-1.899-0.533 0.32 0.149 0.661 0.256 0.981 0.427 0.299 0.171 0.597 0.107 0.917 0.107zM19.029 27.435c0 0.021 0 0.021 0.021 0.043 0.256-0.064 0.491-0.149 0.768-0.235-0.32-0.085-0.533 0.107-0.789 0.192z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M25.813 14.571c0.021 2.027-0.341 3.968-1.152 5.845-0.939 2.176-2.347 3.968-4.309 5.312-2.197 1.493-4.629 2.048-7.253 1.6-2.091-0.363-3.861-1.323-5.376-2.773-1.771-1.685-2.901-3.733-3.52-6.080-0.768-2.965-0.64-5.909 0.427-8.768 0.747-2.005 1.899-3.755 3.52-5.163 1.515-1.301 3.243-2.155 5.227-2.453 2.155-0.32 4.203 0.064 6.101 1.109 2.112 1.152 3.669 2.837 4.779 4.971 1.003 1.92 1.515 3.968 1.579 6.123-0.021 0.064-0.021 0.171-0.021 0.277zM24.853 14.827c0-2.176-0.448-4.16-1.387-6.037-1.024-2.005-2.475-3.648-4.501-4.693-3.072-1.579-6.101-1.451-9.024 0.363-2.005 1.237-3.371 3.051-4.288 5.205-0.875 2.069-1.152 4.224-0.917 6.464 0.256 2.539 1.173 4.821 2.816 6.784 1.173 1.408 2.624 2.453 4.373 3.029 2.411 0.789 4.736 0.597 6.976-0.576 1.856-0.96 3.243-2.411 4.267-4.203 1.152-1.984 1.685-4.139 1.685-6.336z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M26.432 11.669c0.256 0 0.469 0 0.704 0 0.341 0 0.683 0 1.024 0 0.128 0 0.171 0.043 0.171 0.149 0.021 0.128 0.043 0.256 0.064 0.384-0.064 0-0.107 0.021-0.128 0.021-0.533 0-1.067 0-1.579 0-0.107 0-0.149-0.021-0.171-0.128-0.021-0.149-0.064-0.277-0.085-0.427z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M27.435 8.875c-0.107 0-0.192 0-0.256 0-0.491 0-0.981 0-1.451 0-0.107 0-0.171-0.021-0.192-0.128-0.043-0.128-0.107-0.256-0.171-0.405 0.064 0 0.107-0.021 0.149-0.021 0.512 0 1.045 0 1.557 0 0.107 0 0.171 0.021 0.213 0.128 0.021 0.149 0.085 0.277 0.149 0.427z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M28.16 18.325c-0.043 0.171-0.085 0.341-0.128 0.491 0 0.021-0.064 0.064-0.107 0.064-0.576 0-1.131 0-1.707 0 0 0-0.021 0-0.043-0.021 0.043-0.149 0.085-0.32 0.128-0.469 0-0.021 0.064-0.064 0.085-0.064 0.576 0 1.152 0 1.771 0z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M26.667 16.128c0.619 0 1.237 0 1.856 0-0.021 0.171-0.021 0.32-0.043 0.469 0 0.021-0.043 0.064-0.085 0.064-0.576 0-1.173 0-1.771 0 0-0.192 0.021-0.363 0.043-0.533z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M24.043 6.101c0.576 0 1.131 0 1.664 0 0.043 0 0.085 0.021 0.107 0.043 0.128 0.149 0.235 0.32 0.384 0.512-0.107 0-0.171 0-0.235 0-0.469 0-0.96 0-1.429 0-0.064 0-0.149-0.043-0.213-0.107-0.085-0.128-0.171-0.277-0.277-0.448z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M26.176 10.56c0.107 0 0.213 0 0.299 0 0.469 0 0.96 0 1.429 0 0.107 0 0.149 0.021 0.171 0.128 0.021 0.128 0.064 0.256 0.107 0.405-0.064 0-0.107 0.021-0.149 0.021-0.533 0-1.045 0-1.579 0-0.107 0-0.149-0.021-0.171-0.128-0.043-0.149-0.085-0.277-0.107-0.427z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M27.861 10.005c-0.619 0-1.216 0-1.792 0-0.043 0-0.085-0.021-0.085-0.064-0.064-0.149-0.107-0.299-0.171-0.491 0.171 0 0.299 0 0.427 0 0.427 0 0.875 0 1.301 0 0.085 0 0.149 0.021 0.171 0.128 0.043 0.128 0.085 0.256 0.149 0.427z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M26.667 13.312c-0.021-0.171-0.043-0.341-0.064-0.512 0.043 0 0.085-0.021 0.149-0.021 0.533 0 1.045 0 1.579 0 0.107 0 0.171 0.021 0.171 0.149s0.021 0.256 0.043 0.384c-0.64 0-1.259 0-1.877 0z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M28.565 15.552c-0.619 0-1.216 0-1.835 0 0-0.149 0-0.299 0-0.469 0-0.021 0.043-0.064 0.085-0.064 0.576 0 1.173 0 1.749 0 0 0.171 0 0.341 0 0.533z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M28.373 17.216c-0.043 0.171-0.064 0.32-0.085 0.469 0 0.043-0.064 0.085-0.085 0.085-0.576 0-1.173 0-1.771 0 0.021-0.171 0.043-0.32 0.085-0.469 0-0.021 0.064-0.064 0.085-0.064 0.597-0.021 1.173-0.021 1.771-0.021z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M26.731 13.888c0.384 0 0.747 0 1.131 0 0.192 0 0.384 0 0.576 0 0.085 0 0.128 0.021 0.128 0.128 0 0.128 0 0.277 0 0.427-0.064 0-0.128 0-0.171 0-0.491 0-1.003 0-1.493 0-0.128 0-0.171-0.043-0.171-0.171 0-0.107 0-0.235 0-0.384z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M26.901 7.765c-0.619 0-1.195 0-1.771 0-0.021 0-0.085-0.021-0.085-0.043-0.085-0.149-0.171-0.32-0.277-0.491 0.085 0 0.128-0.021 0.171-0.021 0.491 0 1.003 0 1.493 0 0.107 0 0.171 0.043 0.213 0.128 0.085 0.149 0.149 0.277 0.256 0.427z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M25.792 19.989c0.064-0.171 0.107-0.32 0.171-0.469 0.021-0.021 0.064-0.064 0.085-0.064 0.576 0 1.152 0 1.771 0-0.064 0.171-0.128 0.341-0.192 0.491-0.021 0.021-0.064 0.064-0.107 0.064-0.555-0.021-1.109-0.021-1.728-0.021z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M25.344 21.077c0.064-0.149 0.128-0.299 0.192-0.448 0.021-0.043 0.064-0.064 0.107-0.064 0.555 0 1.131 0 1.685 0 0 0 0.021 0 0.043 0.021-0.064 0.149-0.149 0.32-0.213 0.469-0.021 0.021-0.064 0.043-0.107 0.043-0.555 0-1.109 0-1.643 0-0.021 0-0.021 0-0.064-0.021z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M23.147 5.013c0.448 0 0.853 0.021 1.259 0 0.299-0.021 0.512 0.064 0.683 0.299 0.064 0.085 0.128 0.149 0.213 0.256-0.064 0-0.107 0.021-0.171 0.021-0.469 0-0.939 0-1.408 0-0.064 0-0.149-0.043-0.192-0.085-0.128-0.171-0.235-0.32-0.384-0.491z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M26.816 21.696c-0.107 0.171-0.192 0.32-0.299 0.469-0.021 0.021-0.064 0.043-0.107 0.043-0.533 0-1.045 0-1.579 0-0.021 0-0.021 0-0.064-0.021 0.085-0.171 0.171-0.32 0.256-0.469 0.021-0.021 0.064-0.043 0.107-0.043 0.533 0 1.067 0 1.621 0 0 0 0.021 0 0.064 0.021z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M24.043 23.317c0.128-0.192 0.235-0.341 0.341-0.491 0.021-0.021 0.064-0.043 0.107-0.043 0.512 0 1.045 0 1.557 0 0 0 0.021 0 0.043 0.021-0.128 0.171-0.256 0.32-0.384 0.469-0.021 0.021-0.064 0.021-0.085 0.021-0.512 0.021-1.024 0.021-1.579 0.021z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M24.149 4.416c-0.085 0-0.128 0.021-0.171 0.021-0.405 0-0.832 0-1.237 0-0.085 0-0.171-0.043-0.235-0.085-0.149-0.128-0.299-0.277-0.469-0.427 0.064 0 0.107-0.021 0.149-0.021 0.384 0 0.768 0 1.131 0 0.085 0 0.171 0.043 0.235 0.085 0.213 0.107 0.384 0.256 0.597 0.427z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M25.173 23.915c-0.171 0.171-0.341 0.32-0.491 0.469-0.021 0.021-0.064 0.043-0.085 0.043-0.469 0-0.939 0-1.451 0 0.171-0.192 0.299-0.363 0.448-0.533 0.021-0.021 0.064-0.021 0.085-0.021 0.469 0 0.939 0 1.408 0 0.021 0.021 0.043 0.021 0.085 0.043z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M23.957 25.045c-0.213 0.149-0.427 0.32-0.64 0.469-0.021 0.021-0.043 0.021-0.064 0.021-0.384 0-0.768 0-1.216 0 0.213-0.192 0.384-0.363 0.576-0.533 0.021-0.021 0.043-0.021 0.085-0.021 0.427 0 0.853 0 1.259 0-0.021 0.043 0 0.043 0 0.064z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M20.587 2.795c0.341 0 0.661 0 1.003 0 0.021 0 0.064 0 0.085 0.021 0.299 0.149 0.597 0.32 0.896 0.469 0 0.021 0 0.043-0.021 0.043-0.171 0-0.341-0.021-0.491 0-0.469 0.043-0.917-0.021-1.259-0.363-0.064-0.064-0.128-0.085-0.213-0.149 0 0 0-0.021 0-0.021z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M22.336 26.155c-0.32 0.149-0.619 0.32-0.939 0.469-0.085 0.043-0.192 0.021-0.299 0.021-0.171 0-0.341 0-0.533-0.021 0.256-0.171 0.491-0.341 0.747-0.512 0.021-0.021 0.043-0.021 0.085-0.021 0.32 0 0.619 0 0.939 0-0.021 0.043 0 0.043 0 0.064z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M20.181 2.197c-0.32 0-0.619 0.064-0.917-0.085-0.32-0.171-0.661-0.277-0.981-0.427 0.64 0.085 1.28 0.277 1.899 0.512z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M19.029 27.435c0.256-0.085 0.469-0.277 0.789-0.192-0.277 0.085-0.533 0.149-0.768 0.235 0-0.021-0.021-0.021-0.021-0.043z"
		></path>
		<path
			fill="#26496b"
			style="fill: var(--color2, #26496b)"
			d="M24.853 14.827c-0.021 2.197-0.533 4.352-1.685 6.357-1.024 1.792-2.411 3.243-4.267 4.203-2.24 1.152-4.587 1.365-6.976 0.576-1.749-0.576-3.2-1.621-4.373-3.029-1.664-1.963-2.56-4.245-2.816-6.784-0.235-2.219 0.064-4.395 0.917-6.464 0.896-2.155 2.261-3.968 4.288-5.205 2.923-1.792 5.973-1.941 9.024-0.363 2.027 1.045 3.477 2.688 4.501 4.693 0.939 1.835 1.387 3.84 1.387 6.016zM5.568 14.677c0 0.277-0.021 0.555 0 0.832 0.128 2.112 0.747 4.075 1.899 5.867 1.109 1.685 2.56 2.965 4.459 3.691 2.069 0.789 4.139 0.704 6.144-0.213 1.92-0.875 3.328-2.304 4.352-4.139 1.003-1.771 1.493-3.691 1.536-5.717 0.043-2.731-0.64-5.227-2.261-7.424-1.131-1.536-2.56-2.688-4.395-3.307-2.112-0.704-4.16-0.555-6.165 0.427-1.6 0.789-2.837 2.005-3.797 3.52-1.216 1.984-1.771 4.139-1.771 6.464z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M14.101 14.144c0 0.299 0 0.555 0 0.832-0.064 0-0.128 0-0.171 0-1.195 0-2.389 0-3.563 0-0.149 0-0.192 0.043-0.192 0.192 0 0.683 0 1.365 0 2.048 0 0.043 0 0.107 0 0.192 0.725 0 1.451 0 2.176 0s1.451 0 2.176 0c0 0.277 0 0.555 0 0.832-1.771 0-3.52 0-5.312 0 0-2.368 0-4.736 0-7.104 1.707 0 3.413 0 5.12 0 0 0.277 0 0.533 0 0.832-1.387 0-2.773 0-4.16 0 0 0.725 0 1.451 0 2.176 1.301 0 2.603 0 3.925 0z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M15.275 15.040c0-0.256 0-0.491 0-0.725 0.256 0 0.491 0 0.725 0-0.064-0.32-0.149-0.619-0.192-0.939-0.171-1.301 0.619-2.261 1.941-2.368 0.597-0.043 1.173 0.064 1.664 0.448 0.448 0.341 0.661 0.832 0.747 1.387-0.299 0.043-0.576 0.085-0.853 0.128-0.021-0.107-0.043-0.213-0.064-0.299-0.277-0.939-1.408-1.28-2.112-0.64-0.256 0.235-0.363 0.533-0.384 0.853 0 0.469 0.128 0.896 0.256 1.344 0.021 0.043 0.085 0.085 0.149 0.085 0.405 0 0.811 0 1.216 0 0.064 0 0.107 0 0.192 0 0 0.235 0 0.469 0 0.725-0.448 0-0.875 0-1.344 0 0.149 0.427 0.107 0.832-0.085 1.195-0.171 0.363-0.405 0.683-0.597 1.024-0.021 0 0 0 0.021 0 0.555-0.128 1.088-0.064 1.621 0.085 0.448 0.107 0.896 0.213 1.344 0.107 0.192-0.043 0.384-0.128 0.576-0.192 0.085 0.256 0.192 0.512 0.277 0.789-0.491 0.256-0.981 0.363-1.515 0.277-0.32-0.064-0.64-0.149-0.96-0.256-0.704-0.235-1.365-0.171-2.027 0.171-0.107 0.043-0.192 0.107-0.32 0.149-0.107-0.277-0.213-0.533-0.299-0.789 0-0.021 0.043-0.085 0.085-0.128 0.405-0.256 0.704-0.597 0.875-1.067 0.149-0.405 0.171-0.832 0.085-1.259-0.021-0.085-0.064-0.128-0.149-0.128-0.32 0.021-0.597 0.021-0.875 0.021z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M23.573 30.293c0.299 0 0.533 0.235 0.533 0.533v0c0 0.299-0.235 0.533-0.533 0.533h-14.933c-0.299 0-0.533-0.235-0.533-0.533v0c0-0.299 0.235-0.533 0.533-0.533z"
		></path>
	</symbol>

	<!-- sports -->
	<symbol [id]="ICONS.sports" viewBox="0 0 32 32">
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M9.259 17.813c-0.939 0-1.792 0.32-2.475 0.853 0-0.064-0.021-0.128-0.021-0.192 0-0.725 0.299-1.451 0.896-1.963 0.128-0.107 0.149-0.299 0.043-0.448-0.107-0.128-0.299-0.149-0.448-0.043-0.768 0.619-1.131 1.536-1.131 2.432 0 1.045 0.533 2.069 1.557 2.645 0 0.597-0.213 1.131-0.555 1.536-0.789-0.256-1.493-0.789-1.941-1.557-0.32-0.533-0.469-1.131-0.469-1.728 0-0.704 0.213-1.387 0.619-1.963 0.107-0.149 0.064-0.341-0.085-0.427-0.149-0.107-0.341-0.064-0.427 0.085-0.469 0.683-0.725 1.493-0.725 2.325 0 0.683 0.171 1.387 0.555 2.027 0.469 0.811 1.173 1.387 1.963 1.728-0.427 0.299-0.917 0.469-1.429 0.469-0.277 0-0.576-0.043-0.853-0.149-0.171-0.064-0.341 0.021-0.405 0.192s0.021 0.341 0.192 0.405c0.363 0.128 0.725 0.192 1.088 0.192 0.811 0 1.6-0.32 2.176-0.875 0.043-0.043 0.085-0.085 0.128-0.128 0 0 0.021-0.021 0.021-0.021 0.491-0.533 0.811-1.259 0.811-2.091 0.405-0.235 0.811-0.341 1.216-0.341 0.128 0 0.256 0.021 0.384 0.021 0.064 0.235 0.085 0.491 0.085 0.747 0 0.576-0.149 1.173-0.469 1.728-0.64 1.109-1.792 1.728-2.987 1.728-0.085 0-0.192 0-0.277-0.021-0.171-0.021-0.32 0.107-0.341 0.277s0.107 0.32 0.277 0.341c0.107 0 0.213 0.021 0.32 0.021 1.408 0 2.773-0.725 3.541-2.048 0.363-0.64 0.555-1.344 0.555-2.027 0-0.171-0.021-0.363-0.043-0.533 0.704 0.341 1.28 1.003 1.408 1.835 0.021 0.171 0.192 0.277 0.363 0.256s0.277-0.192 0.256-0.363c-0.213-1.301-1.195-2.24-2.389-2.517 0 0-0.021 0-0.021 0-0.213-0.043-0.448-0.085-0.683-0.085-0.512 0-1.045 0.128-1.536 0.427-0.512-0.299-0.875-0.747-1.067-1.237 0.619-0.555 1.429-0.896 2.325-0.896 1.387 0 2.56 0.811 3.115 1.963 0.064 0.149 0.256 0.213 0.427 0.149 0.149-0.064 0.213-0.256 0.149-0.427-0.661-1.344-2.069-2.304-3.691-2.304z"
		></path>
		<path
			fill="#4f6081"
			style="fill: var(--color2, #4f6081)"
			d="M5.483 25.28c0.789 0.448 1.643 0.661 2.496 0.661 1.728 0 3.413-0.896 4.352-2.496 0.448-0.789 0.661-1.643 0.661-2.496 0-1.728-0.896-3.413-2.496-4.352-0.789-0.448-1.643-0.661-2.496-0.661-1.728 0-3.413 0.896-4.352 2.496-0.448 0.789-0.661 1.664-0.661 2.496 0 1.749 0.896 3.435 2.496 4.352zM4.203 18.752c0.811-1.408 2.283-2.197 3.797-2.197 0.747 0 1.493 0.192 2.176 0.597 1.408 0.811 2.197 2.283 2.197 3.797 0 0.747-0.192 1.493-0.597 2.176-0.811 1.408-2.283 2.197-3.797 2.197-0.747 0-1.493-0.192-2.176-0.597-1.408-0.811-2.197-2.283-2.197-3.797 0-0.725 0.192-1.493 0.597-2.176z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M27.819 17.408l-1.28 1.28-0.939-0.939 1.28-1.28-0.512-0.512-1.28 1.28-0.96-0.96-0.512 0.512 0.939 0.96-1.301 1.301-0.917-0.917-0.512 0.512 0.917 0.917-1.365 1.365 0.512 0.512 1.365-1.365 0.939 0.939-1.365 1.365 0.512 0.512 1.365-1.365 0.917 0.917 0.512-0.512-0.917-0.917 1.301-1.301 0.96 0.96 0.512-0.512-0.96-0.96 1.28-1.28-0.491-0.512zM24.725 20.501l-0.939-0.939 1.301-1.301 0.939 0.939-1.301 1.301z"
		></path>
		<path
			fill="#4f6081"
			style="fill: var(--color2, #4f6081)"
			d="M17.365 26.965c0.213 0.192 0.491 0.299 0.747 0.299 0.277 0 0.555-0.107 0.768-0.32l1.728-1.749c0 0 0.32-0.491 0.32-0.768 0-0.149-0.043-0.32-0.107-0.448 0.597-0.533 1.536-0.981 2.261-1.003l1.216-0.021c0.427 0 0.875-0.107 1.323-0.256 0.576-0.213 1.152-0.576 1.621-1.067 0.875-0.875 1.323-1.963 1.323-3.008 0-0.768-0.256-1.536-0.832-2.091-0.555-0.555-1.301-0.832-2.091-0.832-1.045 0-2.155 0.469-3.008 1.323-0.491 0.491-0.853 1.045-1.067 1.621-0.171 0.427-0.256 1.323-0.256 1.323v0l-0.021 1.216c0 0.725-0.448 1.664-1.003 2.261-0.149-0.064-0.299-0.107-0.448-0.107-0.277 0-0.555 0.107-0.768 0.32l-1.749 1.749 0.512 0.512 1.749-1.749c0.064-0.064 0.171-0.107 0.256-0.107s0.192 0.043 0.256 0.107c0.064 0.064 0.107 0.171 0.107 0.256s-0.043 0.192-0.107 0.256l-1.749 1.749c-0.064 0.064-0.171 0.107-0.256 0.107s-0.171 0-0.235-0.043c0-0.021-0.021-0.021-0.021-0.043-0.064-0.064-0.107-0.171-0.107-0.256s0.043-0.192 0.107-0.256v0l-0.512-0.512c-0.213 0.213-0.32 0.491-0.32 0.768 0.043 0.256 0.149 0.576 0.363 0.768v0zM22.059 19.989v0c0-0.341 0.085-0.704 0.213-1.067 0.192-0.491 0.491-0.96 0.896-1.387 0.747-0.747 1.685-1.131 2.496-1.131 0.619 0 1.173 0.213 1.579 0.619s0.619 0.96 0.619 1.579c0 0.832-0.384 1.771-1.131 2.496-0.427 0.427-0.896 0.725-1.387 0.896-0.363 0.128-0.725 0.213-1.067 0.213h-0.043c-0.619 0-1.173-0.213-1.579-0.619s-0.619-0.96-0.619-1.579l0.021-0.021zM21.931 21.888c0.064 0.085 0.128 0.171 0.213 0.256s0.171 0.149 0.256 0.213c-0.235 0.064-0.469 0.128-0.704 0.235 0.107-0.235 0.192-0.469 0.235-0.704zM17.237 26.773v-0.043c0 0 0.021 0.021 0 0.043v0z"
		></path>
		<path
			fill="#4f6081"
			style="fill: var(--color2, #4f6081)"
			d="M18.603 18.475c0.725 0 1.429-0.64 1.429-1.451 0-0.789-0.64-1.451-1.451-1.451-0.789 0-1.429 0.64-1.429 1.451s0.725 1.451 1.451 1.451zM18.581 16.32c0.405 0 0.725 0.32 0.725 0.725s-0.363 0.725-0.725 0.725c-0.363 0-0.725-0.32-0.725-0.725 0.021-0.405 0.341-0.725 0.725-0.725z"
		></path>
		<path
			fill="none"
			opacity="0.5"
			stroke="#0969b1"
			stroke-width="0.8667"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="round"
			style="stroke: var(--color3, #0969b1)"
			d="M21.973 10.624c-0.917-0.213-1.387-0.747-1.771-1.344-0.235-0.363-0.789-0.341-1.045 0-0.597 0.811-1.515 1.472-2.944 1.472-1.451 0-2.368-0.832-2.965-1.6-0.256-0.32-0.747-0.32-0.96 0.021-0.405 0.64-0.875 1.216-1.856 1.451"
		></path>
		<path
			fill="none"
			opacity="0.5"
			stroke="#0969b1"
			stroke-width="0.8667"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="round"
			style="stroke: var(--color3, #0969b1)"
			d="M21.973 13.525c-0.917-0.213-1.387-0.747-1.771-1.344-0.235-0.363-0.789-0.341-1.045 0-0.619 0.832-1.536 1.472-2.965 1.472-1.451 0-2.368-0.832-2.965-1.6-0.448-0.576-0.533-0.64-0.96 0.021-0.405 0.64-0.875 1.216-1.856 1.451"
		></path>
		<path
			fill="none"
			stroke="#506081"
			stroke-width="0.8667"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="round"
			style="stroke: var(--color4, #506081)"
			d="M11.563 8.171l2.005-1.216c0.469-0.277 0.555-0.896 0.213-1.301l-0.555-0.661c-0.277-0.32-0.256-0.811 0.043-1.109 0.341-0.341 0.875-0.32 1.195 0.043l3.755 4.267"
		></path>
		<path
			fill="none"
			stroke="#506081"
			stroke-width="0.8667"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="round"
			style="stroke: var(--color4, #506081)"
			d="M19.093 6.144c0.789 0 1.451-0.64 1.451-1.451s-0.64-1.451-1.451-1.451-1.451 0.64-1.451 1.451 0.64 1.451 1.451 1.451z"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color1, #0769b1)"
			d="M23.573 30.293c0.299 0 0.533 0.235 0.533 0.533v0c0 0.299-0.235 0.533-0.533 0.533h-14.933c-0.299 0-0.533-0.235-0.533-0.533v0c0-0.299 0.235-0.533 0.533-0.533z"
		></path>
	</symbol>

	<!-- calender -->
	<symbol [id]="ICONS.calender" viewBox="0 0 32 32">
		<path
			fill="none"
			stroke="#26496b"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color1, #26496b)"
			d="M22.955 1.707v5.632"
		></path>
		<path
			fill="none"
			stroke="#26496b"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color1, #26496b)"
			d="M8.832 1.707v5.632"
		></path>
		<path
			fill="#0769b1"
			stroke="#26496b"
			stroke-width="1.28"
			stroke-miterlimit="133.333"
			stroke-linecap="butt"
			stroke-linejoin="miter"
			style="fill: var(--color2, #0769b1); stroke: var(--color1, #26496b)"
			d="M3.2 11.541c0-2.667 0-3.989 0.832-4.821s2.155-0.832 4.821-0.832h14.101c2.667 0 3.989 0 4.821 0.832s0.832 2.155 0.832 4.821v1.408h-25.408v-1.408z"
		></path>
		<path
			fill="none"
			stroke="#26496b"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="butt"
			stroke-linejoin="miter"
			style="stroke: var(--color1, #26496b)"
			d="M6.016 5.931h19.755c1.557 0 2.816 1.259 2.816 2.816v15.509c0 1.557-1.259 2.816-2.816 2.816h-19.755c-1.557 0-2.816-1.259-2.816-2.816v-15.488c0-1.557 1.259-2.837 2.816-2.837z"
		></path>
		<path
			fill="none"
			stroke="#0969b1"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color3, #0969b1)"
			d="M7.424 18.624h5.632"
		></path>
		<path
			fill="none"
			stroke="#0969b1"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color3, #0969b1)"
			d="M18.731 18.624h5.632"
		></path>
		<path
			fill="none"
			stroke="#0969b1"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color3, #0969b1)"
			d="M7.424 22.869h5.632"
		></path>
		<path
			fill="none"
			stroke="#0969b1"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color3, #0969b1)"
			d="M18.731 22.869h5.632"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color2, #0769b1)"
			d="M23.573 30.293c0.299 0 0.533 0.235 0.533 0.533v0c0 0.299-0.235 0.533-0.533 0.533h-14.933c-0.299 0-0.533-0.235-0.533-0.533v0c0-0.299 0.235-0.533 0.533-0.533z"
		></path>
	</symbol>

	<!-- No Data -->
	<symbol [id]="ICONS.noData" viewBox="0 0 32 32">
		<path
			fill="#3a70b7"
			style="fill: var(--color1, #3a70b7)"
			d="M22.315 29.077c-0.043 0.32-0.213 0.427-0.533 0.427-5.269 0-10.539 0-15.808 0-0.405 0-0.512-0.128-0.512-0.533 0-0.448 0-0.917 0-1.408-0.427 0-0.832 0-1.237 0-0.64 0-0.683-0.043-0.683-0.661 0-4.907 0-9.792 0-14.699 0-2.027 0-4.053 0-6.059 0-0.277 0.085-0.469 0.277-0.661 1.557-1.557 3.115-3.093 4.672-4.651 0.149-0.149 0.32-0.235 0.555-0.235 4.779 0 9.536 0 14.315 0 0.448 0 0.533 0.085 0.533 0.533s0 0.917 0 1.387c0.491 0 0.96 0 1.408 0 0.405 0 0.533 0.107 0.533 0.512 0 6.976 0 13.952 0 20.949 0 0.277-0.085 0.469-0.384 0.512-0.363-0.064-0.363-0.32-0.363-0.619 0-6.741 0-13.483 0-20.224 0-0.128 0-0.256 0-0.405-0.427 0-0.789 0-1.195 0 0 0.149 0 0.277 0 0.427 0 6.165 0 12.331 0 18.496 0 0.277-0.043 0.533-0.384 0.576-0.363-0.085-0.363-0.341-0.363-0.64 0-6.784 0-13.589 0-20.373 0-0.128 0-0.256 0-0.405-4.651 0-9.28 0-13.909 0 0 0.128 0 0.235 0 0.363 0 1.323 0 2.624 0 3.947 0 0.576-0.085 0.661-0.64 0.661-1.323 0-2.645 0-3.968 0-0.107 0-0.213 0-0.341 0 0 6.869 0 13.675 0 20.544 0.128 0 0.256 0 0.384 0 3.136 0 6.251 0 9.387 0 1.941 0 3.883 0 5.824 0 0.256 0 0.469 0.064 0.533 0.363-0.043 0.32-0.256 0.384-0.533 0.384-4.416 0-8.853 0-13.269 0-0.128 0-0.235 0-0.363 0 0 0.405 0 0.789 0 1.195 0.149 0 0.277 0 0.405 0 5.035 0 10.048 0 15.083 0 0.235-0.021 0.469 0 0.576 0.299zM4.885 5.525c1.195 0 2.389 0 3.584 0 0-1.216 0-2.411 0-3.584-1.195 1.195-2.389 2.389-3.584 3.584z"
		></path>
		<path
			fill="#3a70b6"
			style="fill: var(--color2, #3a70b6)"
			d="M25.429 25.621c0.811 0.832 1.643 1.643 2.453 2.496 1.067 1.109 0.555 2.859-0.917 3.221-0.683 0.171-1.301-0.043-1.813-0.533-0.597-0.576-1.195-1.173-1.792-1.749-0.619-0.619-1.237-1.259-1.856-1.877-0.256-0.277-0.512-0.533-0.789-0.811-0.384-0.405-0.597-0.875-0.597-1.429 0-0.085-0.021-0.213-0.085-0.277-0.149-0.192-0.341-0.363-0.512-0.533-0.107 0.064-0.171 0.107-0.213 0.128-1.557 1.024-3.264 1.429-5.12 1.195-4.096-0.512-6.997-4.416-6.272-8.512 0.555-3.136 2.453-5.163 5.547-5.973 2.837-0.747 5.867 0.384 7.659 2.752 1.856 2.475 1.941 5.845 0.256 8.469-0.064 0.085-0.149 0.235-0.128 0.256 0.213 0.213 0.448 0.576 0.704 0.597 0.597 0.064 1.109 0.235 1.536 0.64 0.661 0.661 1.301 1.301 1.941 1.941zM15.232 11.499c-3.691 0-6.656 2.944-6.677 6.635-0.021 3.52 2.752 6.677 6.656 6.677 3.691 0 6.635-2.901 6.635-6.635 0.021-3.904-3.115-6.699-6.613-6.677zM20.096 23.723c0.235 0.213 0.469 0.405 0.64 0.619 0.107 0.128 0.149 0.32 0.149 0.491-0.021 0.384 0.064 0.704 0.341 0.96 1.515 1.515 3.008 3.029 4.523 4.523 0.427 0.427 1.216 0.405 1.643-0.021 0.448-0.448 0.469-1.173 0.021-1.643-1.493-1.515-3.008-3.029-4.523-4.523-0.277-0.277-0.64-0.363-1.024-0.341-0.149 0.021-0.32-0.043-0.427-0.128-0.213-0.192-0.405-0.448-0.619-0.683-0.277 0.299-0.491 0.491-0.725 0.747z"
		></path>
		<path
			fill="#bbd6f1"
			style="fill: var(--color3, #bbd6f1)"
			d="M25.429 25.621c-0.64-0.64-1.28-1.301-1.941-1.941 0-0.32 0-0.619 0-0.939 0.341-0.043 0.384-0.277 0.384-0.576 0-6.165 0-12.331 0-18.496 0-0.128 0-0.256 0-0.427 0.405 0 0.768 0 1.195 0 0 0.128 0 0.256 0 0.405 0 6.741 0 13.483 0 20.224 0 0.299 0.021 0.555 0.363 0.619 0 0.384 0 0.768 0 1.131z"
		></path>
		<path
			fill="#bbd6f1"
			style="fill: var(--color3, #bbd6f1)"
			d="M21.525 27.179c0.619 0.619 1.237 1.259 1.856 1.877-0.363 0-0.704 0-1.067 0-0.107-0.277-0.341-0.32-0.619-0.32-5.035 0-10.048 0-15.083 0-0.128 0-0.256 0-0.405 0 0-0.405 0-0.789 0-1.195 0.128 0 0.256 0 0.363 0 4.416 0 8.853 0 13.269 0 0.277 0 0.491-0.064 0.533-0.384 0.384 0.021 0.768 0.021 1.152 0.021z"
		></path>
		<path
			fill="#fff"
			style="fill: var(--color4, #fff)"
			d="M21.525 27.179c-0.384 0-0.747 0-1.131 0-0.064-0.299-0.277-0.363-0.533-0.363-1.941 0-3.883 0-5.824 0-3.136 0-6.251 0-9.387 0-0.128 0-0.235 0-0.384 0 0-6.869 0-13.675 0-20.544 0.128 0 0.235 0 0.341 0 1.323 0 2.645 0 3.968 0 0.555 0 0.64-0.085 0.64-0.661 0-1.323 0-2.624 0-3.947 0-0.107 0-0.235 0-0.363 4.651 0 9.259 0 13.909 0 0 0.128 0 0.256 0 0.405 0 6.784 0 13.589 0 20.373 0 0.277 0 0.555 0.363 0.64 0 0.32 0 0.619 0 0.939-0.427-0.405-0.939-0.576-1.536-0.64-0.256-0.021-0.491-0.384-0.704-0.597-0.021-0.021 0.064-0.171 0.128-0.256 1.685-2.624 1.6-5.995-0.256-8.469-1.771-2.368-4.8-3.499-7.659-2.752-3.072 0.811-4.971 2.837-5.547 5.973-0.725 4.096 2.176 7.979 6.272 8.512 1.856 0.235 3.563-0.149 5.12-1.195 0.064-0.043 0.128-0.085 0.213-0.128 0.171 0.171 0.341 0.363 0.512 0.533 0.064 0.064 0.085 0.192 0.085 0.277 0.021 0.555 0.213 1.024 0.597 1.429 0.277 0.299 0.533 0.576 0.811 0.832zM16.192 4.672c-1.493 0-2.987 0-4.501 0-0.256 0-0.427 0.064-0.469 0.341-0.021 0.235 0.149 0.384 0.448 0.384 0.043 0 0.107 0 0.149 0 2.901 0 5.781 0 8.683 0 0.128 0 0.256 0 0.363-0.043 0.235-0.064 0.341-0.277 0.213-0.469-0.085-0.128-0.299-0.235-0.448-0.235-1.472 0.021-2.944 0.021-4.437 0.021zM16.213 2.752c-1.451 0-2.923 0-4.373 0-0.107 0-0.235-0.021-0.299 0.021-0.128 0.085-0.299 0.235-0.277 0.341 0.021 0.128 0.171 0.256 0.299 0.363 0.064 0.043 0.171 0.021 0.277 0.021 2.901 0 5.803 0 8.704 0 0.107 0 0.235 0.021 0.299-0.021 0.107-0.085 0.277-0.213 0.256-0.32 0-0.128-0.149-0.277-0.256-0.363-0.064-0.043-0.192-0.021-0.299-0.021-1.429-0.021-2.88-0.021-4.331-0.021zM18.368 6.613c-0.768 0-1.515 0-2.283 0-0.256 0-0.469 0.064-0.491 0.363-0.021 0.235 0.171 0.384 0.491 0.384 1.515 0 3.029 0 4.565 0 0.256 0 0.469-0.064 0.491-0.363 0.021-0.235-0.171-0.384-0.491-0.384-0.768 0-1.515 0-2.283 0zM18.347 9.301c0.789 0 1.557 0 2.347 0 0.213 0 0.384-0.064 0.448-0.299 0.064-0.256-0.128-0.448-0.448-0.448-0.811 0-1.621 0-2.432 0-0.725 0-1.451 0-2.176 0-0.32 0-0.491 0.171-0.448 0.405 0.043 0.256 0.213 0.32 0.448 0.32 0.725 0.021 1.493 0.021 2.261 0.021z"
		></path>
		<path
			fill="#85b2e0"
			style="fill: var(--color5, #85b2e0)"
			d="M4.885 5.525c1.195-1.195 2.389-2.389 3.584-3.584 0 1.173 0 2.368 0 3.584-1.195 0-2.389 0-3.584 0z"
		></path>
		<path
			fill="#bbd6f1"
			style="fill: var(--color3, #bbd6f1)"
			d="M15.232 11.499c3.499 0 6.635 2.773 6.613 6.677 0 3.712-2.944 6.635-6.635 6.635-3.904 0-6.677-3.157-6.656-6.677 0.021-3.691 2.965-6.656 6.677-6.635zM15.232 23.509c2.987 0 5.355-2.368 5.355-5.376 0-2.987-2.389-5.376-5.376-5.376s-5.397 2.432-5.397 5.419c0 2.944 2.432 5.333 5.419 5.333z"
		></path>
		<path
			fill="#85b2e0"
			style="fill: var(--color5, #85b2e0)"
			d="M20.096 23.723c0.235-0.235 0.448-0.448 0.704-0.704 0.213 0.235 0.384 0.469 0.619 0.683 0.107 0.085 0.299 0.149 0.427 0.128 0.405-0.043 0.747 0.064 1.024 0.341 1.515 1.515 3.029 3.008 4.523 4.523 0.448 0.448 0.427 1.173-0.021 1.643-0.427 0.427-1.216 0.448-1.643 0.021-1.515-1.515-3.029-3.008-4.523-4.523-0.256-0.256-0.341-0.597-0.341-0.96 0-0.171-0.043-0.363-0.149-0.491-0.149-0.256-0.384-0.448-0.619-0.661z"
		></path>
		<path
			fill="#3b71b7"
			style="fill: var(--color6, #3b71b7)"
			d="M16.192 4.672c1.493 0 2.987 0 4.459 0 0.149 0 0.363 0.107 0.448 0.235 0.128 0.192 0.021 0.384-0.213 0.469-0.107 0.043-0.256 0.043-0.363 0.043-2.901 0-5.781 0-8.683 0-0.043 0-0.107 0-0.149 0-0.299-0.021-0.469-0.149-0.448-0.384 0.021-0.277 0.213-0.341 0.469-0.341 1.472-0.021 2.987-0.021 4.48-0.021z"
		></path>
		<path
			fill="#3b71b7"
			style="fill: var(--color6, #3b71b7)"
			d="M16.213 2.752c1.451 0 2.901 0 4.352 0 0.107 0 0.235-0.021 0.299 0.021 0.107 0.085 0.256 0.235 0.256 0.363 0 0.107-0.149 0.256-0.256 0.32-0.064 0.043-0.192 0.021-0.299 0.021-2.901 0-5.803 0-8.704 0-0.085 0-0.213 0.043-0.277-0.021-0.128-0.107-0.277-0.235-0.299-0.363 0-0.107 0.149-0.256 0.277-0.341 0.064-0.043 0.192-0.021 0.299-0.021 1.451 0.021 2.901 0.021 4.352 0.021z"
		></path>
		<path
			fill="#3b71b7"
			style="fill: var(--color6, #3b71b7)"
			d="M18.368 6.613c0.768 0 1.515 0 2.283 0 0.32 0 0.512 0.149 0.491 0.384-0.021 0.299-0.235 0.363-0.491 0.363-1.515 0-3.029 0-4.565 0-0.32 0-0.512-0.149-0.491-0.384 0.021-0.299 0.235-0.363 0.491-0.363 0.768 0 1.536 0 2.283 0z"
		></path>
		<path
			fill="#3b71b7"
			style="fill: var(--color6, #3b71b7)"
			d="M18.347 9.301c-0.768 0-1.515 0-2.283 0-0.235 0-0.405-0.064-0.448-0.32s0.149-0.405 0.448-0.405c0.725 0 1.451 0 2.176 0 0.811 0 1.621 0 2.432 0 0.32 0 0.512 0.192 0.448 0.448-0.064 0.235-0.235 0.299-0.448 0.299-0.768-0.021-1.557-0.021-2.325-0.021z"
		></path>
		<path
			fill="#3a70b6"
			style="fill: var(--color2, #3a70b6)"
			d="M15.232 23.509c-2.987 0-5.419-2.389-5.419-5.333 0-2.987 2.411-5.419 5.376-5.419 2.987 0 5.376 2.389 5.376 5.376 0 3.008-2.347 5.376-5.333 5.376zM15.232 13.483c-2.581 0-4.672 2.048-4.672 4.608 0 2.603 2.048 4.693 4.629 4.693 2.539 0.043 4.651-2.069 4.672-4.629s-2.069-4.651-4.629-4.672z"
		></path>
		<path
			fill="#ddeaf9"
			style="fill: var(--color7, #ddeaf9)"
			d="M15.232 13.483c2.56 0 4.651 2.112 4.629 4.672s-2.133 4.651-4.672 4.629c-2.581-0.021-4.651-2.112-4.629-4.693 0-2.56 2.091-4.608 4.672-4.608zM15.232 18.624c0.085 0.107 0.128 0.192 0.192 0.256 0.448 0.448 0.875 0.896 1.323 1.323 0.085 0.085 0.277 0.149 0.405 0.107 0.107-0.021 0.235-0.192 0.235-0.277 0-0.128-0.085-0.299-0.192-0.405-0.491-0.512-0.981-0.981-1.557-1.579 0.128-0.064 0.235-0.107 0.32-0.192 0.448-0.427 0.875-0.875 1.323-1.323 0.171-0.171 0.192-0.363 0.021-0.533s-0.363-0.149-0.533 0.021c-0.064 0.064-0.128 0.128-0.192 0.192-0.448 0.448-0.917 0.917-1.408 1.429-0.085-0.107-0.149-0.213-0.213-0.299-0.427-0.448-0.875-0.875-1.301-1.301-0.171-0.171-0.363-0.192-0.555-0.021-0.171 0.171-0.128 0.363 0.021 0.533 0.064 0.085 0.149 0.149 0.213 0.213 0.448 0.448 0.896 0.896 1.387 1.365-0.128 0.128-0.256 0.213-0.363 0.32-0.405 0.405-0.832 0.811-1.237 1.237-0.085 0.085-0.128 0.277-0.107 0.384s0.171 0.235 0.277 0.235c0.128 0 0.277-0.085 0.363-0.171 0.533-0.448 1.024-0.96 1.579-1.515z"
		></path>
		<path
			fill="#3a70b6"
			style="fill: var(--color2, #3a70b6)"
			d="M15.232 18.624c-0.555 0.555-1.045 1.067-1.557 1.557-0.085 0.085-0.256 0.171-0.363 0.171s-0.256-0.149-0.277-0.235c-0.021-0.107 0.021-0.299 0.107-0.384 0.405-0.427 0.811-0.832 1.237-1.237 0.107-0.107 0.213-0.192 0.363-0.32-0.469-0.469-0.917-0.917-1.387-1.365-0.064-0.064-0.149-0.149-0.213-0.213-0.149-0.171-0.192-0.363-0.021-0.533s0.384-0.149 0.555 0.021c0.427 0.427 0.875 0.875 1.301 1.301 0.085 0.085 0.128 0.192 0.213 0.299 0.512-0.512 0.96-0.96 1.408-1.429 0.064-0.064 0.128-0.128 0.192-0.192 0.171-0.149 0.363-0.171 0.533-0.021 0.171 0.171 0.149 0.363-0.021 0.533-0.448 0.448-0.875 0.896-1.323 1.323-0.085 0.085-0.192 0.128-0.32 0.192 0.576 0.576 1.088 1.067 1.557 1.579 0.107 0.107 0.192 0.256 0.192 0.405 0 0.107-0.128 0.256-0.235 0.277-0.128 0.021-0.32-0.021-0.405-0.107-0.448-0.427-0.896-0.875-1.323-1.323-0.085-0.107-0.128-0.192-0.213-0.299z"
		></path>
	</symbol>

	<!-- offDays -->
	<symbol [id]="ICONS.offDays" viewBox="0 0 32 32">
		<path
			fill="none"
			stroke="#26496b"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color1, #26496b)"
			d="M22.955 1.707v5.632"
		></path>
		<path
			fill="none"
			stroke="#26496b"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color1, #26496b)"
			d="M8.832 1.707v5.632"
		></path>
		<path
			fill="#0769b1"
			stroke="#26496b"
			stroke-width="1.28"
			stroke-miterlimit="133.333"
			stroke-linecap="butt"
			stroke-linejoin="miter"
			style="fill: var(--color2, #0769b1); stroke: var(--color1, #26496b)"
			d="M3.2 11.541c0-2.667 0-3.989 0.832-4.821s2.155-0.832 4.821-0.832h14.101c2.667 0 3.989 0 4.821 0.832s0.832 2.155 0.832 4.821v1.408h-25.408v-1.408z"
		></path>
		<path
			fill="none"
			stroke="#26496b"
			stroke-width="1.6924"
			stroke-miterlimit="133.333"
			stroke-linecap="butt"
			stroke-linejoin="miter"
			style="stroke: var(--color1, #26496b)"
			d="M6.016 5.931h19.755c1.557 0 2.816 1.259 2.816 2.816v15.509c0 1.557-1.259 2.816-2.816 2.816h-19.755c-1.557 0-2.816-1.259-2.816-2.816v-15.488c0-1.557 1.259-2.837 2.816-2.837z"
		></path>
		<path
			fill="none"
			stroke="#ff3000"
			stroke-width="2.9025"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color3, #ff3000)"
			d="M11.861 17.536l7.808 5.717"
		></path>
		<path
			fill="none"
			stroke="#ff3000"
			stroke-width="2.9025"
			stroke-miterlimit="133.333"
			stroke-linecap="round"
			stroke-linejoin="miter"
			style="stroke: var(--color3, #ff3000)"
			d="M19.541 17.344l-7.787 5.717"
		></path>
		<path
			fill="#0769b1"
			style="fill: var(--color2, #0769b1)"
			d="M23.573 30.293c0.299 0 0.533 0.235 0.533 0.533v0c0 0.299-0.235 0.533-0.533 0.533h-14.933c-0.299 0-0.533-0.235-0.533-0.533v0c0-0.299 0.235-0.533 0.533-0.533z"
		></path>
	</symbol>

	<!-- Mail Success -->
	<symbol [id]="ICONS.mailSuccess" viewBox="0 0 32 32">
		<path
			fill="#3cb54a"
			style="fill: var(--color1, #3cb54a)"
			d="M32 21c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5z"
		></path>
		<path
			fill="#0e9347"
			style="fill: var(--color2, #0e9347)"
			d="M31 20c-0.552 0-1 0.448-1 1 0 2.485-2.015 4.5-4.5 4.5-0.552 0-1 0.448-1 1s0.448 1 1 1c3.59 0 6.5-2.91 6.5-6.5-0-0.552-0.448-1-1-1z"
		></path>
		<path
			fill="#89c763"
			style="fill: var(--color3, #89c763)"
			d="M20 22c0.552 0 1-0.448 1-1 0-2.485 2.015-4.5 4.5-4.5 0.552 0 1-0.448 1-1s-0.448-1-1-1c-3.59 0-6.5 2.91-6.5 6.5 0 0.552 0.448 1 1 1z"
		></path>
		<path
			fill="#fff"
			style="fill: var(--color4, #fff)"
			d="M29.205 18.295c-0.39-0.391-1.023-0.391-1.414-0.001-0 0-0 0-0.001 0.001l-3.29 3.295-1.19-1.18c-0.029-0.041-0.060-0.079-0.095-0.115-0.39-0.391-1.023-0.391-1.414-0.001-0 0-0 0-0.001 0.001-0.391 0.39-0.391 1.023-0.001 1.414 0 0 0 0 0.001 0.001v0l2 2c0.39 0.391 1.023 0.391 1.414 0.001 0-0 0-0 0.001-0.001l4-4c0.388-0.393 0.384-1.026-0.009-1.414-0-0-0-0.001-0.001-0.001z"
		></path>
		<path
			fill="#dddfe1"
			style="fill: var(--color5, #dddfe1)"
			d="M29.205 18.295c-0.086-0.084-0.185-0.152-0.295-0.2 0.169 0.378 0.088 0.822-0.205 1.115v0l-4 4c-0.39 0.391-1.023 0.391-1.414 0.001-0-0-0-0-0.001-0.001l0.5 0.5c0.39 0.391 1.023 0.391 1.414 0.001 0-0 0-0 0.001-0.001l4-4c0.364-0.385 0.341-1.009-0-1.415z"
		></path>
		<path
			fill="#0e9347"
			style="fill: var(--color2, #0e9347)"
			d="M29.705 18.795c-0.086-0.084-0.185-0.152-0.295-0.2 0.169 0.378 0.088 0.822-0.205 1.115v0l-4 4c-0.39 0.391-1.023 0.391-1.414 0.001-0-0-0-0-0.001-0.001l0.5 0.5c0.39 0.391 1.023 0.391 1.414 0.001 0-0 0-0 0.001-0.001l4-4c0.351-0.383 0.318-1.002-0-1.415z"
		></path>
		<path
			fill="#ffcb5b"
			style="fill: var(--color6, #ffcb5b)"
			d="M17.065 19.95c0.581-4.658 4.829-7.963 9.487-7.382 1.72 0.215 3.333 0.95 4.623 2.107 0.21 0.18 0.526 0.155 0.705-0.055 0.076-0.089 0.119-0.203 0.12-0.32v-8.3c0-0.828-0.672-1.5-1.5-1.5h-29.085c-0.781 0-1.415 0.633-1.415 1.415v20.17c0 0.781 0.633 1.415 1.415 1.415v0h17.385c0.276-0.003 0.498-0.229 0.495-0.505-0.001-0.117-0.044-0.231-0.12-0.32-1.643-1.831-2.413-4.284-2.11-6.725z"
		></path>
		<path
			fill="#ffdb6f"
			style="fill: var(--color7, #ffdb6f)"
			d="M31.5 6.785l-14 7.885c-0.913 0.513-2.027 0.513-2.94 0l-14.060-7.885c-0.311-0.179-0.501-0.511-0.5-0.87v0c0-0.781 0.633-1.415 1.415-1.415h29.17c0.781 0 1.415 0.633 1.415 1.415v0 0c0.001 0.359-0.189 0.691-0.5 0.87z"
		></path>
		<path
			fill="#f7b84e"
			style="fill: var(--color8, #f7b84e)"
			d="M32 5.95c-0.011 0.346-0.2 0.662-0.5 0.835l-14 7.885c-0.913 0.513-2.027 0.513-2.94 0l-14.060-7.885c-0.075-0.043-0.144-0.095-0.205-0.155-0.051-0.052-0.096-0.109-0.135-0.17v-0.025c-0.092-0.151-0.142-0.323-0.145-0.5h-0.015v1.065c-0.001 0.346 0.177 0.667 0.47 0.85l14.1 8.81c0.893 0.548 1.435 1.522 1.43 2.57v3.235c0 1.676-1.359 3.035-3.035 3.035h-8.465c-1.105 0-2 0.895-2 2h16.3c0.276-0.003 0.498-0.229 0.495-0.505-0.001-0.117-0.044-0.231-0.12-0.32-3.119-3.509-2.802-8.882 0.707-12 3.22-2.862 8.073-2.862 11.293 0 0.21 0.18 0.526 0.155 0.705-0.055 0.076-0.089 0.119-0.203 0.12-0.32v-8.3c-0 0-0-0.030-0-0.050v0z"
		></path>
		<path
			fill="#ffe278"
			style="fill: var(--color9, #ffe278)"
			d="M13.245 11.065l-3.94-2.19c-0.483-0.267-0.658-0.876-0.391-1.359 0.179-0.324 0.522-0.522 0.891-0.516h0.195c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-6c-0.179-0.001-0.345 0.095-0.435 0.25-0.134 0.242-0.047 0.546 0.195 0.68 0 0 0 0 0 0l9 5c0.221 0.165 0.535 0.119 0.7-0.102s0.119-0.535-0.102-0.7c-0.035-0.026-0.072-0.047-0.112-0.063z"
		></path>
		<path
			fill="#ffe278"
			style="fill: var(--color9, #ffe278)"
			d="M12 6h3c0.276 0 0.5 0.224 0.5 0.5v0c0 0.276-0.224 0.5-0.5 0.5h-3c-0.276 0-0.5-0.224-0.5-0.5v0c0-0.276 0.224-0.5 0.5-0.5z"
		></path>
		<path
			fill="#f19920"
			style="fill: var(--color10, #f19920)"
			d="M17.47 14.675c-0.913 0.513-2.027 0.513-2.94 0l-14-7.865c0.052 0.049 0.107 0.094 0.165 0.135l13.71 8.5c0.969 0.602 2.196 0.602 3.165 0l13.71-8.5c0.058-0.041 0.113-0.086 0.165-0.135l-13.975 7.865z"
		></path>
	</symbol>

	<symbol [id]="ICONS.mail" viewBox="0 0 32 32">
		<path
			fill="#f6b154"
			style="fill: var(--color1, #f6b154)"
			d="M32 9.266v0.622c-0.039 0.024-0.092 0.053-0.135 0.082l-1.196 0.709c-0.087 0.048-0.169 0.106-0.27 0.159 0 0.005-0.005 0.005-0.005 0.005h-0.005c-0.309 0.178-0.675 0.391-1.003 0.584-0.207 0.125-0.405 0.236-0.564 0.333l-11.79 6.934c-0.13 0.072-0.275 0.125-0.429 0.164-0.014 0.005-0.029 0.005-0.043 0.010-0.178 0.039-0.371 0.053-0.559 0.043-0.188 0.010-0.381-0.005-0.559-0.043-0.014-0.005-0.029-0.005-0.043-0.010-0.154-0.039-0.299-0.092-0.429-0.164l-0.371-0.222-0.371-0.217-0.357-0.207-0.159-0.096-0.048-0.029-0.28-0.164-10.204-5.999c-0.111-0.063-0.236-0.14-0.371-0.217-0.376-0.222-0.825-0.487-1.196-0.699h-0.005c0 0-0.005 0-0.005-0.005-0.101-0.053-0.183-0.111-0.27-0.159l-1.196-0.709c-0.043-0.029-0.096-0.058-0.135-0.082v-0.622c0-0.106 0.015-0.193 0.043-0.27 0-0.005 0.005-0.005 0.005-0.005 0.029-0.019 0.058-0.034 0.087-0.053l1.196-0.709c0.511-0.294 1.341-0.786 1.847-1.080l0.058-0.034 11.732-6.901c0.284-0.159 0.665-0.231 1.032-0.212 0.366-0.019 0.752 0.053 1.032 0.212l11.79 6.934c0.043 0.024 0.087 0.048 0.135 0.077 0.309 0.183 0.704 0.42 1.075 0.632 0.231 0.14 0.453 0.265 0.637 0.371l1.196 0.709c0.029 0.019 0.058 0.034 0.087 0.053 0.034 0.077 0.048 0.169 0.048 0.275z"
		></path>
		<path
			fill="#000"
			style="fill: var(--color2, #ffe5c4)"
			d="M32 12.034v0.622c-0.039 0.024-0.087 0.053-0.135 0.082l-1.196 0.709c-0.28 0.159-0.656 0.381-1.022 0.593-0.299 0.178-0.598 0.352-0.825 0.487l-11.79 6.934c-0.13 0.072-0.275 0.125-0.429 0.164-0.188 0.048-0.4 0.063-0.603 0.053-0.203 0.010-0.415-0.005-0.603-0.053-0.154-0.039-0.299-0.092-0.429-0.164l-11.79-6.934c-0.178-0.106-0.395-0.231-0.627-0.371-0.424-0.246-0.887-0.521-1.22-0.709l-1.196-0.709c-0.043-0.029-0.096-0.058-0.135-0.082v-0.622c0-0.106 0.015-0.193 0.043-0.27 0-0.005 0.005-0.005 0.005-0.005 0.029-0.019 0.058-0.034 0.087-0.053l1.196-0.709c0.082-0.048 0.174-0.101 0.27-0.159 0.405-0.236 0.911-0.535 1.317-0.767 0.010-0.010 0.024-0.014 0.034-0.019 0.082-0.048 0.154-0.096 0.227-0.135l11.79-6.934c0.284-0.159 0.665-0.231 1.032-0.212 0.366-0.019 0.752 0.053 1.032 0.212l11.79 6.934c0.077 0.048 0.169 0.096 0.26 0.154 0.058 0.029 0.116 0.063 0.174 0.101 0.371 0.217 0.791 0.463 1.143 0.665 0.096 0.058 0.188 0.111 0.27 0.159l1.196 0.709c0.029 0.019 0.058 0.034 0.087 0.053 0.034 0.077 0.048 0.169 0.048 0.275z"
		></path>
		<path
			fill="#7cbe3a"
			style="fill: var(--color3, #7cbe3a)"
			d="M27.323 6.904l-0.198 2.016-0.222 2.305-0.174 1.765-0.285 2.937-0.236 2.445-0.193 1.977-23.841-2.315 0.376-3.877 0.256-2.614 0.14-1.456 0.005-0.034 0.284-2.937 0.246-2.527 19.501 1.895z"
		></path>
		<path
			fill="#000"
			style="fill: var(--color2, #ffe5c4)"
			d="M30.047 17.98l-23.836 2.411-0.203-1.987-0.236-2.353-0.299-2.941-0.178-1.779-0.256-2.508-0.188-1.866 23.836-2.416 0.169 1.673 0.101 1.013 0.28 2.758 0.019 0.188 0.13 1.254 0.26 2.614z"
		></path>
		<path
			fill="#f6ba69"
			style="fill: var(--color4, #f6ba69)"
			d="M16.67 17.368c0 0-0.106 0.063-0.28 0.154-0.106 0.058-0.241 0.125-0.391 0.212-0.072 0.039-0.154 0.082-0.241 0.125l-0.318 0.169-0.043 0.019-0.101 0.058-0.699 0.366-0.964 0.511c-0.087 0.043-0.174 0.092-0.256 0.14-0.149 0.077-0.294 0.159-0.424 0.222-0.232 0.125-0.41 0.222-0.477 0.256-0.053 0.029-0.183 0.096-0.352 0.188l-0.005 0.005c-0.222 0.116-0.506 0.27-0.791 0.419l-9.639 5.116c-0.188 0.096-0.391 0.207-0.579 0.304h-0.579c-0.053 0-0.106 0-0.149-0.005-0.121-0.010-0.207-0.029-0.275-0.058-0.034-0.019-0.063-0.034-0.082-0.053-0.010-0.014-0.015-0.019-0.019-0.034 0-0.015-0.005-0.029 0-0.048-0.005-0.024-0.005-0.048-0.005-0.077v-15.961c0-0.096 0.015-0.178 0.043-0.246 0-0.005 0.005-0.005 0.005-0.005 0.063-0.145 0.178-0.232 0.338-0.246 0.043-0.014 0.087-0.014 0.14-0.010 0.116 0.005 0.251 0.039 0.395 0.121l1.77 0.935 0.193 0.106 0.034 0.019 0.029 0.014 0.757 0.4c0.096 0.048 0.203 0.111 0.318 0.169 0.395 0.207 0.882 0.463 1.273 0.675 0.087 0.043 0.169 0.092 0.246 0.13l9.591 5.092c0.010 0.005 0.019 0.005 0.024 0.010 0.019 0.005 0.034 0.015 0.053 0.024 0.043 0.024 0.087 0.043 0.125 0.067 0.005 0.005 0.014 0.005 0.019 0.010 0.058 0.029 0.111 0.058 0.164 0.087 0.212 0.111 0.386 0.203 0.482 0.26 0.058 0.024 0.087 0.043 0.096 0.048 0.019 0.014 0.154 0.082 0.294 0.164 0.005 0 0.005 0.005 0.010 0.005 0.024 0.010 0.048 0.019 0.067 0.034 0.116 0.058 0.203 0.101 0.203 0.106z"
		></path>
		<path
			fill="#f5a84f"
			style="fill: var(--color5, #f5a84f)"
			d="M31.992 9.305c0.005 0.049 0.008 0.147 0.008 0.217v15.701c0 0.070 0 0.14 0 0.156s-0.006 0.061-0.006 0.070c0 0.008 0 0.015 0 0.033 0 0 0 0.001 0 0.002s-0.047 0.035-0.106 0.074l-0.292 0.061c-0.070 0.008-0.184 0.015-0.255 0.015h-0.324c-0.070 0-0.179-0.027-0.241-0.059l-0.354-0.186c-0.062-0.033-0.164-0.086-0.226-0.119l-9.413-4.994c-0.062-0.033-0.164-0.087-0.226-0.12l-0.923-0.494c-0.062-0.033-0.163-0.087-0.225-0.12l-0.929-0.494c-0.062-0.033-0.163-0.087-0.225-0.12l-1.542-0.816c-0.062-0.033-0.164-0.087-0.226-0.119l-0.137-0.072c-0.062-0.033-0.164-0.086-0.226-0.119 0 0-0.054-0.028-0.127-0.067-0.385-0.209-0.669-0.361-0.669-0.366s0.123-0.065 0.268-0.144c0.145-0.078 0.194-0.105 0.194-0.105 0.062-0.033 0.121-0.065 0.132-0.071s0.126-0.065 0.187-0.098c0 0 0.334-0.183 0.68-0.361 0.017-0.009 0.017-0.009 0.017-0.009 0.018-0.010 0.037-0.019 0.042-0.022s0.060-0.030 0.109-0.057 0.14-0.075 0.202-0.108l9.185-4.873c0.062-0.033 0.163-0.087 0.226-0.12l1.614-0.855c0.062-0.033 0.164-0.087 0.226-0.12l2.556-1.356c0.062-0.033 0.166-0.082 0.23-0.109 0 0 0.084-0.039 0.153-0.050s0.182-0.011 0.251 0.002l0.263 0.138c0.047 0.052 0.122 0.205 0.127 0.254z"
		></path>
		<path
			fill="#e68737"
			style="fill: var(--color6, #e68737)"
			d="M32 23.426v1.93c0 0.030 0 0.055-0.006 0.081 0.006 0.017 0 0.030 0 0.047 0 0 0 0 0 0.004-0.040 0.089-0.223 0.145-0.537 0.145h-29.282l13.878-9.238 0.623 0.272 15.324 6.76z"
		></path>
		<path
			fill="#f6b154"
			style="fill: var(--color1, #f6b154)"
			d="M32 25.284v0.072c0 0.030 0 0.055-0.006 0.081 0.006 0.017 0 0.030 0 0.047 0 0 0 0 0 0.004-0.039 0.089-0.218 0.145-0.524 0.145h-30.941c-0.307 0-0.485-0.055-0.524-0.145 0-0.004 0-0.004 0-0.004 0-0.017-0.006-0.030 0-0.047-0.006-0.026-0.006-0.051-0.006-0.081v-0.072c0.050-0.051 0.123-0.102 0.217-0.153l14.879-8.331c0.006 0 0.006-0.004 0.011-0.008 0.017-0.009 0.034-0.017 0.050-0.026 0.307-0.166 0.619-0.281 0.842-0.323 0.078 0.017 0.162 0.038 0.256 0.072 0.178 0.055 0.385 0.145 0.585 0.251 0.022 0.013 0.039 0.021 0.061 0.034l14.879 8.331c0.095 0.055 0.167 0.106 0.218 0.153z"
		></path>
	</symbol>

	<symbol [id]="ICONS.mailError" viewBox="0 0 32 32">
		<path
			fill="#f4b2b0"
			style="fill: var(--color1, #f4b2b0)"
			d="M26.745 6.548v-0.229h-25.897v0.229l12.949 10.434z"
		></path>
		<path
			fill="#b3404a"
			style="fill: var(--color2, #b3404a)"
			d="M32 21.272c0-2.609-1.912-4.779-4.408-5.186v-4.021c0-0.468-0.38-0.848-0.848-0.848s-0.848 0.38-0.848 0.848v4.021c-2.080 0.339-3.753 1.903-4.254 3.925l-2.485-2.135c-0.355-0.305-0.89-0.264-1.195 0.091s-0.264 0.89 0.091 1.195l3.516 3.020c0.178 1.012 0.645 1.926 1.314 2.651h-19.948l6.602-5.671c0.355-0.305 0.396-0.84 0.091-1.195s-0.84-0.396-1.195-0.091l-6.739 5.789v-15.345l11.569 9.323c0.155 0.125 0.344 0.188 0.532 0.188s0.377-0.063 0.532-0.188l12.949-10.434c0.2-0.161 0.316-0.404 0.316-0.66v-0.229c0-0.468-0.38-0.848-0.848-0.848h-25.897c-0.468 0-0.848 0.38-0.848 0.848v19.361c0 0.468 0.38 0.848 0.848 0.848h25.897c0.014 0 0.029-0.001 0.043-0.002 2.878-0.023 5.212-2.371 5.212-5.254zM24.626 7.167l-10.83 8.727-10.83-8.727h21.66zM26.745 24.832c-1.963 0-3.56-1.597-3.56-3.56s1.597-3.56 3.56-3.56 3.56 1.597 3.56 3.56-1.597 3.56-3.56 3.56z"
		></path>
		<path
			fill="#b3404a"
			style="fill: var(--color2, #b3404a)"
			d="M26.745 21.604c-0.468 0-0.848-0.38-0.848-0.848v-1.568c0-0.468 0.38-0.848 0.848-0.848s0.848 0.38 0.848 0.848v1.568c0 0.468-0.38 0.848-0.848 0.848z"
		></path>
		<path
			fill="#b3404a"
			style="fill: var(--color2, #b3404a)"
			d="M26.745 23.914c-0.468 0-0.848-0.38-0.848-0.848v-0.042c0-0.468 0.38-0.848 0.848-0.848s0.848 0.38 0.848 0.848v0.042c0 0.468-0.38 0.848-0.848 0.848z"
		></path>
	</symbol>
	<symbol [id]="ICONS.profile" viewBox="-120.65 -120.65 643.46 643.46">
		<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
		<g
			id="SVGRepo_tracerCarrier"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke="#CCCCCC"
			stroke-width="5.429"
		></g>
		<!-- Increased stroke-width -->
		<g id="SVGRepo_iconCarrier">
			<g>
				<g>
					<g>
						<path
							fill="#d6303b"
							stroke="#d6303b"
							stroke-width="5.429"
							d="M201.08,49.778c-38.794,0-70.355,31.561-70.355,70.355c0,18.828,7.425,40.193,19.862,57.151 c14.067,19.181,32,29.745,50.493,29.745c18.494,0,36.426-10.563,50.494-29.745c12.437-16.958,19.862-38.323,19.862-57.151 C271.436,81.339,239.874,49.778,201.08,49.778z M201.08,192.029c-13.396,0-27.391-8.607-38.397-23.616 c-10.46-14.262-16.958-32.762-16.958-48.28c0-30.523,24.832-55.355,55.355-55.355s55.355,24.832,55.355,55.355 C256.436,151.824,230.372,192.029,201.08,192.029z"
						/>
						<path
							fill="#d6303b"
							stroke="#d6303b"
							stroke-width="5.429"
							d="M201.08,0C109.387,0,34.788,74.598,34.788,166.292c0,91.693,74.598,166.292,166.292,166.292 s166.292-74.598,166.292-166.292C367.372,74.598,292.773,0,201.08,0z M201.08,317.584c-30.099-0.001-58.171-8.839-81.763-24.052 c0.82-22.969,11.218-44.503,28.824-59.454c6.996-5.941,17.212-6.59,25.422-1.615c8.868,5.374,18.127,8.099,27.52,8.099 c9.391,0,18.647-2.724,27.511-8.095c8.201-4.97,18.39-4.345,25.353,1.555c17.619,14.93,28.076,36.526,28.895,59.512 C259.25,308.746,231.178,317.584,201.08,317.584z M296.981,283.218c-3.239-23.483-15.011-45.111-33.337-60.64 c-11.89-10.074-29.1-11.256-42.824-2.939c-12.974,7.861-26.506,7.86-39.483-0.004c-13.74-8.327-30.981-7.116-42.906,3.01 c-18.31,15.549-30.035,37.115-33.265,60.563c-33.789-27.77-55.378-69.868-55.378-116.915C49.788,82.869,117.658,15,201.08,15 c83.423,0,151.292,67.869,151.292,151.292C352.372,213.345,330.778,255.448,296.981,283.218z"
						/>
						<path
							fill="#d6303b"
							stroke="#d6303b"
							stroke-width="5.429"
							d="M302.806,352.372H99.354c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h203.452c4.142,0,7.5-3.358,7.5-7.5 C310.307,355.73,306.948,352.372,302.806,352.372z"
						/>
						<path
							fill="#d6303b"
							stroke="#d6303b"
							stroke-width="5.429"
							d="M302.806,387.161H99.354c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h203.452c4.142,0,7.5-3.358,7.5-7.5 C310.307,390.519,306.948,387.161,302.806,387.161z"
						/>
					</g>
				</g>
			</g>
		</g>
	</symbol>
	<symbol [id]="ICONS.check" viewBox="0 0 32 32">
		<path
			d="M7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM11.4731 4.71938C11.1804 4.42456 10.7038 4.42371 10.41 4.7175L6.70574 8.42176C6.31575 8.81175 5.68364 8.81236 5.2929 8.42313L4.58676 7.71971C4.29429 7.42838 3.82116 7.42883 3.52926 7.72074C3.23696 8.01304 3.23696 8.48696 3.52926 8.77926L5.29289 10.5429C5.68342 10.9334 6.31658 10.9334 6.70711 10.5429L11.4712 5.77875C11.7636 5.48643 11.7644 5.01274 11.4731 4.71938Z"
			fill="#2DC937"
		/>
	</symbol>
	<symbol [id]="ICONS.checkWhite" viewBox="0 0 32 32">
		<path
			d="M7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM11.4731 4.71938C11.1804 4.42456 10.7038 4.42371 10.41 4.7175L6.70574 8.42176C6.31575 8.81175 5.68364 8.81236 5.2929 8.42313L4.58676 7.71971C4.29429 7.42838 3.82116 7.42883 3.52926 7.72074C3.23696 8.01304 3.23696 8.48696 3.52926 8.77926L5.29289 10.5429C5.68342 10.9334 6.31658 10.9334 6.70711 10.5429L11.4712 5.77875C11.7636 5.48643 11.7644 5.01274 11.4731 4.71938Z"
			fill="#fff"
		/>
	</symbol>
	<symbol [id]="ICONS.notSelected_check" viewBox="0 0 32 32">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0 7.50588C0 3.3605 3.3605 0 7.50588 0C11.6513 0 15.0117 3.3605 15.0117 7.50588C15.0117 11.6512 11.6513 15.0117 7.50588 15.0117C3.3605 15.0117 0 11.6512 0 7.50588ZM7.50588 1.07666C3.95512 1.07666 1.07667 3.95512 1.07667 7.50588C1.07667 11.0566 3.95512 13.9351 7.50588 13.9351C11.0566 13.9351 13.935 11.0566 13.935 7.50588C13.935 3.95512 11.0566 1.07666 7.50588 1.07666ZM10.1734 4.83865C10.3946 5.05994 10.3946 5.41874 10.1734 5.64004L8.3074 7.506L10.1734 9.37198C10.3946 9.59328 10.3946 9.95208 10.1734 10.1734C9.95208 10.3947 9.59328 10.3947 9.37198 10.1734L7.506 8.30739L5.64004 10.1734C5.41874 10.3947 5.05994 10.3947 4.83865 10.1734C4.61735 9.95208 4.61735 9.59328 4.83865 9.37198L6.70462 7.506L4.83865 5.64004C4.61735 5.41874 4.61735 5.05994 4.83865 4.83865C5.05994 4.61735 5.41874 4.61735 5.64004 4.83865L7.506 6.70462L9.37198 4.83865C9.59328 4.61735 9.95208 4.61735 10.1734 4.83865Z"
			fill="#81A7BA"
		/>
	</symbol>
	<symbol [id]="ICONS.celebration" viewBox="0 0 512 512">
		<g id="SVGRepo_iconCarrier">
			<path
				fill="#2B3B47"
				d="M384.619 132.759a9.786 9.786 0 0 1-9.786 9.786c-53.909 0-100.22-33.129-119.662-80.093c-19.443 46.965-65.754 80.093-119.664 80.093c-5.405 0-9.786-4.381-9.786-9.786s4.381-9.786 9.786-9.786c60.586 0 109.877-49.291 109.877-109.877c0-5.405 4.381-9.786 9.786-9.786s9.787 4.381 9.787 9.786c0 60.586 49.29 109.877 109.876 109.877a9.786 9.786 0 0 1 9.786 9.786z"
			/>

			<path
				fill="#FFB636"
				d="M1.265 227.373c0-66.976 54.295-121.271 121.271-121.271s121.271 54.295 121.271 121.271m266.928 0c0-66.976-54.295-121.271-121.271-121.271s-121.271 54.295-121.271 121.271"
			/>

			<path
				fill="#FFD469"
				d="M37.587 227.373c0-66.976 72.099-121.271 84.949-121.271S84.12 160.397 84.12 227.373m266.928 0c0-66.976 51.266-121.271 38.416-121.271s-84.949 54.295-84.949 121.271"
			/>

			<path
				fill="#A06C33"
				d="M122.536 250.252c-66.976 0-121.271-8.901-121.271-19.88c0-10.98 54.295-19.88 121.271-19.88s121.271 8.901 121.271 19.88s-54.295 19.88-121.271 19.88zm388.199-19.88c0-10.98-54.295-19.88-121.271-19.88s-121.271 8.901-121.271 19.88c0 10.98 54.295 19.88 121.271 19.88s121.271-8.901 121.271-19.88z"
			/>

			<path
				fill="#FFB636"
				d="M277.001 332.669c0 7.738-6.273 14.011-14.011 14.011s-14.011-6.273-14.011-14.011s6.273-14.011 14.011-14.011s14.011 6.274 14.011 14.011zM341.94 468.19c-6.828 0-12.363 5.535-12.363 12.363c0 6.828 5.535 12.363 12.363 12.363c6.828 0 12.363-5.535 12.363-12.363c0-6.827-5.535-12.363-12.363-12.363zM70.596 404.686c-6.828 0-12.363 5.535-12.363 12.363c0 6.828 5.535 12.363 12.363 12.363c6.828 0 12.363-5.535 12.363-12.363c0-6.828-5.535-12.363-12.363-12.363z"
			/>

			<path
				fill="#BEA4FF"
				d="M151.693 475.554c0 8.939-7.247 16.186-16.186 16.186s-16.186-7.247-16.186-16.186s7.247-16.186 16.186-16.186c8.94-.001 16.186 7.246 16.186 16.186zM404.11 238.718c-5.911-6.059-14.208-10.141-23.364-11.494c-5.341-.792-10.332 2.905-11.124 8.259c-.791 5.353 2.906 10.333 8.259 11.124c4.866.719 9.314 2.831 12.205 5.793c1.295 1.328 3.4 4.013 2.947 7.079c-.453 3.066-3.245 5.027-4.869 5.923c-3.625 2.001-8.492 2.733-13.359 2.015c-19.888-2.936-38.048 8.03-40.478 24.455c-2.428 16.424 11.779 32.179 31.67 35.12c.104.015.206.011.31.023c9.652 1.544 15.567 7.947 14.847 12.816c-.453 3.065-3.245 5.027-4.869 5.923c-3.625 2-8.492 2.736-13.359 2.015c-19.887-2.938-38.048 8.03-40.478 24.455c-2.428 16.424 11.779 32.179 31.67 35.12c.485.071.968.106 1.445.106c4.776 0 8.959-3.498 9.679-8.365c.791-5.352-2.906-10.332-8.259-11.124c-9.836-1.454-15.88-7.951-15.152-12.871c.728-4.922 8.39-9.399 18.229-7.938c2.191.324 4.382.484 6.548.484c6.878 0 13.506-1.616 19.143-4.727c8.164-4.505 13.553-11.872 14.786-20.213c2.428-16.424-11.779-32.179-31.67-35.12c-.131-.019-.26-.024-.391-.038c-9.603-1.567-15.484-7.946-14.767-12.8c.728-4.922 8.392-9.397 18.229-7.938c2.192.324 4.382.484 6.548.484c6.879 0 13.506-1.616 19.143-4.727c8.164-4.505 13.553-11.872 14.786-20.213c1.233-8.341-1.794-16.952-8.305-23.626z"
			/>

			<path
				fill="#FF6E83"
				d="M288.333 433.236c0 8.939-7.247 16.186-16.186 16.186s-16.186-7.247-16.186-16.186s7.247-16.186 16.186-16.186c8.939-.001 16.186 7.246 16.186 16.186zM120.579 268.85c-6.291-6.119-14.986-10.123-24.484-11.273c-.133-.016-.264-.017-.396-.028c-8.554-1.181-14.349-6.623-13.841-10.816c.746-6.157-3.641-11.753-9.797-12.499c-6.151-.74-11.753 3.641-12.499 9.797c-2.127 17.559 12.731 33.317 33.827 35.874c.118.014.233.011.35.021c4.442.605 8.503 2.419 11.18 5.023c1.139 1.108 3.006 3.336 2.708 5.801c-.298 2.463-2.644 4.18-4.015 4.984c-3.306 1.938-7.826 2.733-12.405 2.177c-9.5-1.153-18.898.659-26.468 5.099c-8.432 4.944-13.881 12.838-14.95 21.655c-2.128 17.56 12.73 33.317 33.826 35.875c.459.056.915.083 1.366.083c5.598 0 10.443-4.182 11.133-9.879c.747-6.157-3.64-11.753-9.796-12.499c-8.772-1.063-14.75-6.62-14.234-10.877c.299-2.464 2.644-4.181 4.016-4.985c3.305-1.938 7.827-2.733 12.404-2.177c1.867.227 3.729.338 5.575.338c7.547 0 14.811-1.869 20.893-5.437c8.433-4.944 13.881-12.838 14.95-21.655c1.069-8.819-2.336-17.786-9.343-24.602zm333.116 229.3c5.186-3.4 6.633-10.361 3.231-15.548c-37.634-57.386-8.78-97.837 8.458-122.005c2.097-2.939 4.077-5.716 5.692-8.206c3.375-5.203 1.894-12.157-3.31-15.532s-12.157-1.893-15.532 3.31c-1.346 2.075-3.102 4.536-5.135 7.387c-17.856 25.035-55.014 77.129-8.954 147.363a11.221 11.221 0 0 0 9.401 5.072a11.17 11.17 0 0 0 6.149-1.841z"
			/>

			<path
				fill="#59CAFC"
				d="M234.634 285.982c0 6.193-5.02 11.213-11.213 11.213s-11.213-5.02-11.213-11.213s5.02-11.213 11.213-11.213s11.213 5.02 11.213 11.213zm239.051-18.867c-6.012 0-10.885 4.874-10.885 10.885s4.873 10.885 10.885 10.885S484.57 284.011 484.57 278s-4.874-10.885-10.885-10.885zM161.53 431.654c1.691-1.831 3.719-3.888 5.867-6.066c10.897-11.054 25.822-26.191 32.28-46.893c7.758-24.87 1.097-51.3-19.8-78.557c-3.627-4.732-10.402-5.624-15.132-1.999c-4.73 3.627-5.625 10.401-1.999 15.132c16.61 21.665 21.95 40.963 16.325 58.995c-4.899 15.703-17.179 28.159-27.045 38.167c-2.274 2.307-4.422 4.485-6.352 6.574c-4.044 4.379-3.773 11.207.605 15.251a10.75 10.75 0 0 0 7.321 2.865a10.76 10.76 0 0 0 7.93-3.469z"
			/>
		</g>
	</symbol>

	<!-- Trophy icon -->
	<symbol [id]="ICONS.trophy">
		<svg
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 512 512"
			xml:space="preserve"
			fill="#000000"
		>
			<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
			<g
				id="SVGRepo_tracerCarrier"
				stroke-linecap="round"
				stroke-linejoin="round"
			></g>
			<g id="SVGRepo_iconCarrier">
				<path
					style="fill: #ecf0f1"
					d="M369.059,52.352v153.537c0,14.104-3.141,27.6-7.329,40.049v0.01 c-16.753,42.384-57.426,72.497-105.474,72.497c-47.975,0-88.98-30.018-105.157-72.298c-0.031-0.063-0.117-0.136-0.138-0.199 c-2.974-7.779-5.095-15.978-6.257-24.469c-0.346-2.544-0.463-5.11-0.641-7.706c-0.178-2.607-0.117-5.235-0.117-7.884V52.352H369.059 z"
				></path>
				<rect
					x="229.813"
					y="319.869"
					style="fill: #f8c660"
					width="52.352"
					height="76.434"
				></rect>
				<path
					style="fill: #ecf0f1"
					d="M329.283,448.654H182.698v-20.581c0-17.546,14.224-31.771,31.771-31.771h83.043 c17.546,0,31.771,14.224,31.771,31.771v20.581H329.283z"
				></path>
				<g>
					<path
						style="fill: #f8c660"
						d="M371.164,501.006H140.816v-20.581c0-17.546,14.224-31.771,31.771-31.771h166.806 c17.546,0,31.771,14.224,31.771,31.771v20.581H371.164z"
					></path>
					<rect
						x="143.433"
						y="9.566"
						style="fill: #f8c660"
						width="225.112"
						height="41.881"
					></rect>
					<path
						style="fill: #f8c660"
						d="M151.039,245.948c-31.17-4.24-59.223-18.711-80.415-39.892 c-25.453-25.453-41.255-60.163-41.255-98.997c0-24.679,19.944-44.237,44.623-44.237h69.956v41.881H74.002 c-1.55,0-2.454,0.806-2.454,2.356c0,45.2,30.517,82.957,72.398,94.631v4.199C143.947,219.992,146.286,233.499,151.039,245.948z"
					></path>
					<path
						style="fill: #f8c660"
						d="M482.67,107.059c0,38.835-15.737,73.769-41.19,99.222c-21.171,21.161-48.894,35.498-80.024,39.768 c4.754-12.449,7.603-26.059,7.603-40.161v-4.146c40.834-11.601,71.993-49.41,71.993-94.683c0-1.55-1.519-2.356-3.069-2.356h-68.923 V62.822h68.923C462.661,62.822,482.67,82.381,482.67,107.059z"
					></path>
					<path
						style="fill: #f8c660"
						d="M314.82,181.996c0,9.537-14.27,15.332-18.725,23.034c-4.596,7.945-2.637,23.153-10.582,27.751 c-7.701,4.455-19.789-4.714-29.325-4.714c-9.537,0-21.624,9.17-29.325,4.714c-7.945-4.596-5.986-19.806-10.582-27.751 c-4.455-7.701-18.726-13.496-18.726-23.034s14.27-15.332,18.725-23.034c4.596-7.945,2.637-23.153,10.582-27.751 c7.701-4.456,19.789,4.714,29.325,4.714c9.537,0,21.624-9.17,29.325-4.714c7.945,4.596,5.986,19.806,10.582,27.751 C300.55,166.663,314.82,172.458,314.82,181.996z"
					></path>
				</g>
				<g>
					<path
						style="fill: #231f20"
						d="M368.757,255.406c30.472-5.416,58.07-19.807,80.124-41.852 c28.54-28.54,44.259-66.191,44.259-106.495c0-30.311-24.743-54.708-55.157-54.708h-58.453c0-1.047,0-1.877,0-2.526V9.566 c0-5.783-5.202-9.566-10.983-9.566H143.435c-5.782,0-9.957,3.783-9.957,9.566v41.881c0,0.129-0.498-0.142-0.494,0.905H73.992 c-30.401,0-55.133,24.388-55.133,54.698c0,40.226,15.726,77.966,44.283,106.524c21.807,21.795,50.146,36.46,80.351,41.837 c9.052,20.653,23.513,38.302,42.126,51.346c10.426,7.306,22.196,12.842,33.713,16.576v63.023h-4.865 c-23.292,0-42.252,18.426-42.252,41.718v10.12c-23.035,0.195-41.881,19.061-41.881,42.232v20.581 c0,5.783,4.698,10.994,10.481,10.994h230.348c5.782,0,10.46-5.211,10.46-10.994v-20.581c0-23.171-18.847-42.037-41.881-42.232 v-10.12c0-23.292-18.939-41.718-42.231-41.718h-4.885v-62.974C326.131,313.015,353.777,288.661,368.757,255.406z M82.214,115.174 h51.263v71.538C105.207,173.57,85.054,145.538,82.214,115.174z M379.53,115.174h50.54c-2.835,30.364-22.27,58.376-50.54,71.562 V115.174z M437.983,73.292c18.869,0,34.218,15.004,34.218,33.767c0,34.71-13.54,67.234-38.123,91.817 c-16.244,16.235-35.974,27.586-57.758,33.471c1.671-7.529,2.622-15.211,2.843-22.923c42.885-15.496,72.201-56.357,72.201-102.349 c0-7.217-6.003-12.843-13.381-12.843h-58.453v-20.94H437.983z M154.417,20.941h204.172v20.941H154.417L154.417,20.941 L154.417,20.941z M77.948,198.653c-24.6-24.601-38.149-56.961-38.149-91.594c0-18.763,15.339-33.767,34.193-33.767h59.485v20.941 H74.002c-7.337,0-13.083,5.488-13.083,12.826c0,24.3,7.814,47.135,22.597,66.286c12.701,16.453,30.134,29.018,49.689,36.066 c0.005,0.192,0.216,12.659,2.723,22.863C114.169,226.347,94.005,214.702,77.948,198.653z M160.799,242.405 c-0.076-0.199,0-0.396-0.088-0.589c-2.621-6.945-6.294-24.425-6.294-35.927V62.822h204.172v143.067 c0,11.082-2.356,23.028-6.875,36.515c-15.889,39.843-53.401,65.571-95.538,65.571C214.182,307.975,175.805,281.625,160.799,242.405 z M360.683,480.426v10.634H151.276v-10.634c0-11.746,9.566-20.777,21.311-20.777h166.806 C351.138,459.648,360.683,468.68,360.683,480.426z M318.802,428.074v10.634H193.157v-10.634c0-11.746,9.566-20.777,21.311-20.777 h83.043C309.257,407.297,318.802,416.328,318.802,428.074z M271.685,386.356h-31.411V327.89c5.235,0.668,10.487,1.025,15.813,1.025 c5.27,0,10.363-0.352,15.598-1.002V386.356z"
					></path>
					<path
						style="fill: #231f20"
						d="M265.132,240.953c4.656,1.641,10.016,3.531,15.5,3.531c3.372,0,6.792-0.715,10.123-2.642 c8.961-5.184,10.768-15.102,12.221-23.074c0.589-3.233,1.256-6.898,2.181-8.497c0.823-1.422,3.681-3.814,5.978-5.737 c5.974-5.003,14.157-11.853,14.157-22.54c0-10.686-8.182-17.537-14.157-22.54c-2.296-1.922-5.155-4.316-5.976-5.737 c-0.926-1.6-1.594-5.264-2.183-8.498c-1.453-7.97-3.26-17.889-12.219-23.071c-8.745-5.06-18.103-1.763-25.624,0.888 c-3.215,1.134-6.861,2.419-8.946,2.419c-2.085,0-5.73-1.285-8.946-2.419c-7.517-2.649-16.875-5.95-25.623-0.888 c-8.961,5.184-10.768,15.102-12.22,23.074c-0.589,3.233-1.257,6.897-2.182,8.496c-0.823,1.422-3.681,3.815-5.978,5.738 c-5.974,5.003-14.157,11.853-14.157,22.54c0,10.686,8.182,17.538,14.157,22.54c2.296,1.923,5.155,4.317,5.976,5.737 c0.926,1.6,1.594,5.264,2.183,8.498c1.453,7.97,3.26,17.889,12.22,23.072c8.744,5.059,18.103,1.762,25.623-0.889 c3.215-1.134,6.861-2.419,8.946-2.419S261.916,239.82,265.132,240.953z M240.279,221.204c-2.428,0.855-6.329,2.23-8.146,2.332 c-0.878-1.629-1.653-5.881-2.134-8.521c-0.895-4.912-1.91-10.479-4.658-15.229c-2.672-4.618-6.732-8.018-10.659-11.306 c-2.226-1.864-5.882-4.926-6.603-6.484c0.72-1.558,4.377-4.621,6.603-6.484c3.926-3.288,7.987-6.686,10.66-11.306 c2.747-4.75,3.762-10.317,4.657-15.228c0.481-2.64,1.255-6.893,2.134-8.521c1.816,0.101,5.718,1.476,8.146,2.332 c4.8,1.692,10.24,3.609,15.907,3.609s11.107-1.917,15.907-3.609c2.428-0.855,6.329-2.231,8.146-2.332 c0.877,1.629,1.653,5.881,2.134,8.521c0.895,4.912,1.91,10.479,4.658,15.229c2.672,4.618,6.732,8.018,10.659,11.305 c2.226,1.864,5.882,4.926,6.603,6.484c-0.72,1.558-4.377,4.621-6.603,6.484c-3.926,3.288-7.987,6.686-10.66,11.306 c-2.747,4.75-3.762,10.317-4.657,15.229c-0.481,2.64-1.255,6.893-2.134,8.521c-1.816-0.101-5.718-1.475-8.146-2.332 c-4.8-1.692-10.239-3.609-15.907-3.609S245.079,219.512,240.279,221.204z"
					></path>
				</g>
			</g>
		</svg>
	</symbol>

	@switch (name()) {
	<!-- Google -->
	@case(ICONS.google){
	<symbol [id]="ICONS.google" viewBox="0 0 32 32">
		<path
			fill="#4285f4"
			style="fill: var(--color1, #4285f4)"
			d="M31.619 16.299c0-1.311-0.106-2.268-0.337-3.26h-14.971v5.917h8.787c-0.177 1.471-1.134 3.685-3.26 5.173l-0.030 0.198 4.733 3.667 0.328 0.033c3.012-2.782 4.748-6.874 4.748-11.729z"
		></path>
		<path
			fill="#34a853"
			style="fill: var(--color2, #34a853)"
			d="M16.311 31.89c4.305 0 7.919-1.417 10.559-3.862l-5.032-3.898c-1.346 0.939-3.154 1.595-5.528 1.595-4.217 0-7.795-2.781-9.071-6.626l-0.187 0.016-4.922 3.809-0.064 0.179c2.622 5.209 8.008 8.788 14.244 8.788z"
		></path>
		<path
			fill="#fbbc05"
			style="fill: var(--color3, #fbbc05)"
			d="M7.24 19.099c-0.337-0.992-0.531-2.055-0.531-3.154s0.195-2.161 0.514-3.154l-0.009-0.211-4.984-3.87-0.163 0.078c-1.081 2.161-1.701 4.589-1.701 7.158s0.62 4.996 1.701 7.157l5.173-4.004z"
		></path>
		<path
			fill="#eb4335"
			style="fill: var(--color4, #eb4335)"
			d="M16.311 6.165c2.994 0 5.014 1.293 6.165 2.374l4.5-4.394c-2.764-2.569-6.36-4.146-10.665-4.146-6.236 0-11.622 3.579-14.244 8.787l5.156 4.004c1.293-3.845 4.872-6.626 9.089-6.626z"
		></path>
	</symbol>

	}

	<!-- Apple -->
	@case(ICONS.apple){
	<!-- Apple -->
	<symbol [id]="ICONS.apple" viewBox="0 0 32 32">
		<path
			d="M20.913 5.109c1.167-1.352 1.953-3.235 1.738-5.109-1.681 0.064-3.715 1.074-4.92 2.424-1.082 1.198-2.027 3.114-1.773 4.95 1.875 0.139 3.789-0.912 4.956-2.266zM25.118 17c0.047 4.843 4.433 6.454 4.482 6.475-0.036 0.114-0.701 2.296-2.31 4.552-1.393 1.949-2.838 3.89-5.114 3.931-2.236 0.040-2.956-1.27-5.514-1.27-2.556 0-3.356 1.229-5.472 1.31-2.197 0.078-3.872-2.109-5.274-4.051-2.87-3.973-5.062-11.227-2.118-16.123 1.463-2.43 4.076-3.971 6.913-4.010 2.157-0.040 4.194 1.39 5.512 1.39s3.794-1.72 6.396-1.467c1.089 0.043 4.147 0.421 6.109 3.174-0.159 0.094-3.648 2.040-3.61 6.088z"
		></path>
	</symbol>

	}

	<!-- Facebook -->
	@case(ICONS.facebookWhite){
	<symbol [id]="ICONS.facebookWhite" viewBox="0 0 32 32">
		<path
			fill="#fff"
			style="fill: var(--color1, #fff)"
			d="M8.434 17.043h3.508v14.441c0 0.285 0.231 0.516 0.516 0.516h5.947c0.285 0 0.516-0.231 0.516-0.516v-14.373h4.032c0.262 0 0.483-0.197 0.513-0.457l0.612-5.316c0.017-0.146-0.030-0.293-0.127-0.402s-0.238-0.173-0.385-0.173h-4.645v-3.333c0-1.005 0.541-1.514 1.608-1.514 0.152 0 3.037 0 3.037 0 0.285 0 0.516-0.231 0.516-0.516v-4.88c0-0.285-0.231-0.516-0.516-0.516h-4.185c-0.030-0.001-0.095-0.004-0.192-0.004-0.726 0-3.25 0.143-5.244 1.977-2.209 2.033-1.902 4.467-1.829 4.889v3.897h-3.682c-0.285 0-0.516 0.231-0.516 0.516v5.248c0 0.285 0.231 0.516 0.516 0.516z"
		></path>
	</symbol>

	}
	<!-- warning -->
	@case (ICONS.warning) {
	<symbol [id]="ICONS.warning" viewBox="0 0 32 32">
		<path
			fill="#fff"
			style="fill: var(--color1, #fff)"
			d="M24.236 18.511h-16.456c-1.186-0.079-1.586-1.165-1.138-1.976l8.23-14.095c0.58-0.869 1.728-0.869 2.276 0l8.225 14.095c0.495 0.901-0.137 1.981-1.138 1.976z"
		></path>
		<path
			fill="#f9c728"
			style="fill: var(--color2, #f9c728)"
			d="M8.587 16.735l7.424-12.725 7.43 12.725z"
		></path>
		<path
			fill="#56ace0"
			style="fill: var(--color3, #56ace0)"
			d="M14.509 20.287h3.009v9.927h-3.009v-9.927z"
		></path>
		<path
			fill="#18375d"
			style="fill: var(--color4, #18375d)"
			d="M16.011 12.557c-0.49 0-0.89-0.395-0.89-0.89v-4.031c0-0.49 0.395-0.89 0.89-0.89s0.89 0.395 0.89 0.89v4.031c0 0.495-0.395 0.89-0.89 0.89z"
		></path>
		<path
			fill="#18375d"
			style="fill: var(--color4, #18375d)"
			d="M16.011 15.892c-0.49 0-0.89-0.395-0.89-0.89v-0.738c0-0.49 0.395-0.89 0.89-0.89s0.89 0.395 0.89 0.89v0.738c0 0.49-0.395 0.89-0.89 0.89z"
		></path>
		<path
			fill="#18375d"
			style="fill: var(--color4, #18375d)"
			d="M26.908 15.639l-8.225-14.095c-1.070-1.96-4.026-2.155-5.343 0l-8.23 14.095c-0.964 1.423-0.385 4.452 2.671 4.653h4.942v9.927h-2.571c-0.49 0-0.89 0.395-0.89 0.89s0.395 0.89 0.89 0.89h11.708c0.49 0 0.89-0.395 0.89-0.89 0-0.49-0.395-0.89-0.89-0.89h-2.571v-9.927h4.942c2.824 0.005 3.694-2.972 2.677-4.653zM17.518 30.219h-3.009v-9.927h3.009v9.927zM24.236 18.511h-16.456c-1.186-0.084-1.586-1.165-1.138-1.976l8.23-14.095c0.58-0.869 1.728-0.869 2.276 0l8.225 14.095c0.495 0.901-0.132 1.981-1.138 1.976z"
		></path>
	</symbol>
	}
	<!-- whatsapp -->
	@case (ICONS.whatsapp) {
	<symbol [id]="ICONS.whatsapp" viewBox="0 0 32 32">
		<path
			fill="#2cb742"
			style="fill: var(--color1, #2cb742)"
			d="M0 32l2.752-8.255c-1.396-2.349-2.2-5.090-2.2-8.020 0-8.684 7.040-15.724 15.724-15.724s15.724 7.040 15.724 15.724-7.040 15.724-15.724 15.724c-2.642 0-5.13-0.655-7.316-1.806l-8.96 2.358z"
		></path>
		<path
			fill="#fff"
			style="fill: var(--color2, #fff)"
			d="M26.308 20.957c-0.726-1.372-3.404-2.941-3.404-2.941-0.606-0.345-1.337-0.384-1.682 0.232 0 0-0.87 1.043-1.091 1.193-1.011 0.685-1.947 0.658-2.892-0.287l-4.393-4.393c-0.945-0.945-0.972-1.881-0.287-2.892 0.15-0.221 1.193-1.091 1.193-1.091 0.616-0.346 0.577-1.076 0.232-1.682 0 0-1.569-2.678-2.941-3.404-0.584-0.309-1.3-0.201-1.767 0.266l-0.97 0.97c-3.077 3.077-1.562 6.551 1.515 9.628l5.624 5.624c3.077 3.077 6.551 4.592 9.628 1.515l0.97-0.97c0.467-0.468 0.574-1.185 0.265-1.768z"
		></path>
	</symbol>
	}

	<!-- Users -->
	@case (ICONS.users) {
	<symbol [id]="ICONS.users" viewBox="0 0 32 32">
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			d="M20.667 10c0 2.577-2.089 4.667-4.667 4.667s-4.667-2.089-4.667-4.667c0-2.577 2.089-4.667 4.667-4.667s4.667 2.089 4.667 4.667z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			opacity="0.4"
			d="M26 10c0 1.841-1.492 3.333-3.333 3.333s-3.333-1.492-3.333-3.333c0-1.841 1.492-3.333 3.333-3.333s3.333 1.492 3.333 3.333z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			opacity="0.4"
			d="M6 10c0 1.841 1.492 3.333 3.333 3.333s3.333-1.492 3.333-3.333c0-1.841-1.492-3.333-3.333-3.333s-3.333 1.492-3.333 3.333z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			d="M24 22c0 2.577-3.582 4.667-8 4.667s-8-2.089-8-4.667c0-2.577 3.582-4.667 8-4.667s8 2.089 8 4.667z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			opacity="0.4"
			d="M29.333 22c0 1.841-2.388 3.333-5.333 3.333s-5.333-1.492-5.333-3.333c0-1.841 2.388-3.333 5.333-3.333s5.333 1.492 5.333 3.333z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			opacity="0.4"
			d="M2.667 22c0 1.841 2.388 3.333 5.333 3.333s5.333-1.492 5.333-3.333c0-1.841-2.388-3.333-5.333-3.333s-5.333 1.492-5.333 3.333z"
		></path>
	</symbol>
	}
	<!-- CUP -->
	@case (ICONS.cup) {
	<symbol [id]="ICONS.cup" viewBox="0 0 32 32">
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			opacity="0.5"
			d="M16.001 21.333c-7.68 0-9.040-7.654-9.281-13.725-0.067-1.689-0.101-2.533 0.534-3.314s1.393-0.909 2.912-1.165c1.499-0.253 3.458-0.462 5.836-0.462s4.337 0.209 5.836 0.462c1.518 0.256 2.277 0.384 2.912 1.165s0.601 1.626 0.534 3.314c-0.241 6.071-1.601 13.725-9.281 13.725z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			d="M23.521 16.563l3.755-2.086c1.003-0.557 1.505-0.836 1.781-1.305s0.276-1.043 0.276-2.191v-0.097c0-1.391 0-2.087-0.377-2.611s-1.037-0.744-2.358-1.184l-1.265-0.422-0.023 0.113c-0.006 0.252-0.017 0.527-0.029 0.829-0.118 2.966-0.503 6.31-1.761 8.954z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			d="M6.719 7.609c0.118 2.966 0.503 6.31 1.761 8.954l-3.756-2.087c-1.003-0.557-1.505-0.836-1.781-1.305s-0.276-1.043-0.276-2.191v-0.097c-0-1.391-0-2.087 0.377-2.611s1.038-0.744 2.358-1.184l1.265-0.422 0.023 0.116c0.006 0.252 0.017 0.526 0.029 0.826z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			d="M7 29.333c0-0.552 0.448-1 1-1h16c0.552 0 1 0.448 1 1s-0.448 1-1 1h-16c-0.552 0-1-0.448-1-1z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			opacity="0.5"
			d="M20.611 28.333h-9.22l0.396-2.333c0.125-0.623 0.672-1.072 1.307-1.072h5.814c0.635 0 1.183 0.449 1.307 1.072l0.396 2.333z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			d="M16 21.334c-0.346 0-0.679-0.016-1-0.046v3.641h2v-3.641c-0.321 0.030-0.654 0.046-1 0.046z"
		></path>
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			d="M14.861 8.030c0.507-0.909 0.76-1.363 1.139-1.363s0.632 0.454 1.139 1.363l0.131 0.235c0.144 0.258 0.216 0.387 0.328 0.473s0.252 0.117 0.532 0.18l0.255 0.058c0.984 0.223 1.476 0.334 1.593 0.71s-0.218 0.769-0.889 1.553l-0.174 0.203c-0.191 0.223-0.286 0.334-0.329 0.472s-0.028 0.287 0 0.584l0.026 0.271c0.101 1.046 0.152 1.57-0.154 1.802s-0.767 0.021-1.688-0.404l-0.238-0.11c-0.262-0.121-0.393-0.181-0.531-0.181s-0.27 0.060-0.531 0.181l-0.238 0.11c-0.921 0.424-1.382 0.636-1.688 0.404s-0.256-0.756-0.154-1.802l0.026-0.271c0.029-0.297 0.043-0.446 0-0.584s-0.138-0.249-0.329-0.472l-0.174-0.203c-0.671-0.784-1.006-1.177-0.889-1.553s0.609-0.488 1.593-0.71l0.255-0.058c0.28-0.063 0.419-0.095 0.532-0.18s0.184-0.214 0.328-0.473l0.131-0.235z"
		></path>
	</symbol>
	}
	<!-- Stadium -->
	@case(ICONS.stadium){
	<symbol [id]="ICONS.stadium" viewBox="0 0 32 32">
		<path
			fill="#0569b1"
			style="fill: var(--color1, #0569b1)"
			d="M2.667 6.667h26.667v18.667h-26.667z"
		></path>
		<path
			fill="#0c446f"
			style="fill: var(--color2, #0c446f)"
			d="M15.333 6.667h1.333v18.667h-1.333z"
		></path>
		<path
			fill="#0c446f"
			style="fill: var(--color2, #0c446f)"
			d="M16 10.667c-2.933 0-5.333 2.4-5.333 5.333s2.4 5.333 5.333 5.333 5.333-2.4 5.333-5.333-2.4-5.333-5.333-5.333zM16 20c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zM29.333 12.667v-1.333h-4.667v9.333h4.667v-1.333h-3.333v-6.667zM2.667 12.667h3.333v6.667h-3.333v1.333h4.667v-9.333h-4.667z"
		></path>
	</symbol>
	}
	<!-- Sport -->
	@case(ICONS.sport){
	<symbol [id]="ICONS.sport" viewBox="0 0 32 32">
		<path
			fill="#fff"
			style="fill: var(--color1, #e41e1e)"
			opacity="0.01"
			d="M0 0h32v32h-32v-32z"
		></path>
		<path
			fill="#2f88ff"
			style="fill: var(--color2, #2f88ff)"
			d="M24 10c1.841 0 3.333-1.492 3.333-3.333s-1.492-3.333-3.333-3.333c-1.841 0-3.333 1.492-3.333 3.333s1.492 3.333 3.333 3.333z"
		></path>
	</symbol>
	}

	<!-- Discount -->
	@case(ICONS.discount){
	<symbol [id]="ICONS.discount" viewBox="0 0 32 32">
		<path
			fill="#94dfff"
			style="fill: var(--color1, #94dfff)"
			d="M20.257 3.65h-8.514l-5.084 7.069v5.152h18.682v-5.152l-5.084-7.069zM16 12.824c-1.669 0-3.022-1.353-3.022-3.022s1.353-3.022 3.022-3.022 3.022 1.353 3.022 3.022-1.353 3.022-3.022 3.022z"
		></path>
		<path
			fill="#3f83f8"
			style="fill: var(--color2, #3f83f8)"
			d="M25.341 16.829c0.529 0 0.958-0.429 0.958-0.958v-5.152c0-0.201-0.063-0.396-0.18-0.559l-5.084-7.069c-0.18-0.25-0.469-0.399-0.778-0.399h-3.299v-1.734c0-0.529-0.429-0.958-0.958-0.958s-0.958 0.429-0.958 0.958v1.734h-3.299c-0.308 0-0.598 0.148-0.778 0.399l-5.084 7.069c-0.117 0.163-0.18 0.359-0.18 0.559v20.323c0 0.529 0.429 0.958 0.958 0.958h18.682c0.529 0 0.958-0.429 0.958-0.958v-9.711c0-0.529-0.429-0.958-0.958-0.958s-0.958 0.429-0.958 0.958v8.753h-16.766v-13.255h17.724zM7.617 11.028l4.617-6.42h2.808v1.331c-1.733 0.43-3.022 1.998-3.022 3.863 0 2.195 1.786 3.98 3.98 3.98s3.98-1.786 3.98-3.98c0-1.864-1.289-3.433-3.022-3.863v-1.331h2.808l4.617 6.42v3.885h-16.766v-3.885zM16 7.738c1.138 0 2.064 0.926 2.064 2.064s-0.926 2.064-2.064 2.064-2.064-0.926-2.064-2.064c0-1.138 0.926-2.064 2.064-2.064z"
		></path>
		<path
			fill="#3f83f8"
			style="fill: var(--color2, #3f83f8)"
			d="M18.843 22.259c-1.159 0-1.797 0.581-1.797 1.637v1.513c0 1.056 0.638 1.637 1.797 1.637 1.142 0 1.797-0.597 1.797-1.637v-1.513c0-1.040-0.655-1.637-1.797-1.637zM18.519 23.896c0-0.228 0.088-0.313 0.323-0.313 0.277 0 0.334 0.125 0.334 0.313v1.513c0 0.188-0.057 0.313-0.334 0.313-0.236 0-0.323-0.085-0.323-0.313v-1.513z"
		></path>
		<path
			fill="#3f83f8"
			style="fill: var(--color2, #3f83f8)"
			d="M17.806 18.392c-0.281 0-0.515 0.142-0.626 0.378l-3.738 7.679c-0.048 0.096-0.074 0.199-0.074 0.291 0 0.369 0.319 0.763 0.795 0.763 0.288 0 0.553-0.153 0.658-0.378l3.749-7.679c0.052-0.105 0.064-0.216 0.064-0.291-0-0.457-0.428-0.763-0.827-0.763z"
		></path>
		<path
			fill="#3f83f8"
			style="fill: var(--color2, #3f83f8)"
			d="M13.158 18.829c-1.159 0-1.797 0.581-1.797 1.637v1.513c0 1.055 0.638 1.637 1.797 1.637 1.142 0 1.797-0.597 1.797-1.637v-1.513c0-1.040-0.655-1.637-1.797-1.637zM12.834 20.465c0-0.228 0.088-0.313 0.323-0.313 0.277 0 0.334 0.125 0.334 0.313v1.513c0 0.188-0.057 0.313-0.334 0.313-0.236 0-0.323-0.085-0.323-0.313v-1.513z"
		></path>
	</symbol>
	} }
</svg>
